document.addEventListener('DOMContentLoaded', () => {
    //All accessibility js code should be here

    if (typeof window.copyAttributes !== 'function') {
        window.copyAttributes = function copyAttributes(source, target) {
            if (!source || !target || !source.attributes) return;
            for (const attr of source.attributes) {
                target.setAttribute(attr.name, attr.value);
            }
        };
    }

    if (typeof window.replaceLinkWithSpan !== 'function') {
        window.replaceLinkWithSpan = function replaceLinkWithSpan(link, secondLink, hasAttrLink, isSecondLinkHidden) {
            if (!link || !secondLink) return null;
            let newLink = link;

            if (hasAttrLink) {
                newLink.setAttribute('role', 'link');
                newLink.setAttribute('tabindex', isSecondLinkHidden ? '-1' : '0');
                if (isSecondLinkHidden) {
                    newLink.setAttribute('aria-hidden', 'true');
                }
            } else {
                newLink = document.createElement('span');
                if (typeof window.copyAttributes === 'function') {
                    window.copyAttributes(link, newLink);
                }
                newLink.innerHTML = link.innerHTML;
                link.replaceWith(newLink);
            }

            newLink.removeAttribute('href');
            newLink.removeAttribute('target');
            newLink.style.cursor = 'pointer';

            newLink.addEventListener('click', (e) => {
                // Prevent navigation if click originated from interactive elements
                const interactiveSelectors = '.wishlistadd, .wis_added, .wis_remve, .compare_add, .js_add_qv, .nt_add_qv, .pr_atc, .js_addtc, [role="button"], button';
                if (e.target.closest(interactiveSelectors)) {
                    return;
                }
                secondLink.click();
            });

            newLink.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    // Prevent navigation if keydown originated from interactive elements
                    const interactiveSelectors = '.wishlistadd, .wis_added, .wis_remve, .compare_add, .js_add_qv, .nt_add_qv, .pr_atc, .js_addtc, [role="button"], button';
                    if (e.target.closest(interactiveSelectors)) {
                        return;
                    }
                    secondLink.click();
                }
            });

            return newLink;
        };
    }


    if (typeof window.getFocusableElements !== 'function') {
        window.getFocusableElements = function getFocusableElements(container) {
            return Array.from(
                container.querySelectorAll(
                    'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
                )
            ).filter((element) => {
                if (element.disabled) return false;
                if (element.closest('[aria-hidden="true"]')) return false;
                return element.tabIndex >= 0;
            });
        };
    }

    if (typeof window.fixProductPriceAccessibility !== 'function') {
        window.fixProductPriceAccessibility = function fixProductPriceAccessibility(container) {
            if (!container) return;
            
            const priceContainers = container.querySelectorAll('.price, .price_range');
            priceContainers.forEach(priceContainer => {
                if (priceContainer.dataset.priceAccessibilityFixed === 'true') return;
                
                const oldPriceValue = priceContainer.querySelector('del');
                const newPriceValue = priceContainer.querySelector('ins');
                
                if (!oldPriceValue || !newPriceValue) return;
                
                if (oldPriceValue.querySelector('.visually-hidden') || newPriceValue.querySelector('.visually-hidden')) {
                    priceContainer.dataset.priceAccessibilityFixed = 'true';
                    return;
                }

                const hiddenOld = document.createElement('span');
                hiddenOld.classList.add('visually-hidden');
                hiddenOld.innerText = 'Formally';
                oldPriceValue.prepend(hiddenOld);

                const hiddenNew = document.createElement('span');
                hiddenNew.classList.add('visually-hidden');
                hiddenNew.innerText = 'Currently';
                newPriceValue.prepend(hiddenNew);

                const oldPriceSpan = document.createElement('span');
                const newPriceSpan = document.createElement('span');

                if (typeof window.copyAttributes === 'function') {
                    window.copyAttributes(oldPriceValue, oldPriceSpan);
                    window.copyAttributes(newPriceValue, newPriceSpan);
                }

                oldPriceSpan.innerHTML = oldPriceValue.innerHTML;
                newPriceSpan.innerHTML = newPriceValue.innerHTML;
                oldPriceSpan.classList.add('old');
                newPriceSpan.classList.add('off');

                oldPriceValue.replaceWith(oldPriceSpan);
                newPriceValue.replaceWith(newPriceSpan);
                
                priceContainer.dataset.priceAccessibilityFixed = 'true';
            });
        };
    }

    if (typeof window.fixProductExtraInfoAccessibility !== 'function') {
        window.fixProductExtraInfoAccessibility = function fixProductExtraInfoAccessibility(product, titleLink, uniqueId) {
            if (!product || !titleLink || !uniqueId) return;
            if (product.dataset.extraInfoAccessibilityFixed === 'true') return;
            
            const describedByIds = [];
            
            const priceContainer = product.querySelector('.price, .price_range');
            if (priceContainer && !priceContainer.id) {
                priceContainer.id = `price_${uniqueId}`;
                describedByIds.push(priceContainer.id);
            } else if (priceContainer && priceContainer.id) {
                describedByIds.push(priceContainer.id);
            }
            
            const labelsContainer = product.querySelector('.nt_labels');
            if (labelsContainer && !labelsContainer.id) {
                labelsContainer.id = `labels_${uniqueId}`;
                describedByIds.push(labelsContainer.id);
            } else if (labelsContainer && labelsContainer.id) {
                describedByIds.push(labelsContainer.id);
            }
            
            const reviewBadge = product.querySelector('.jdgm-preview-badge, .jdgm-widget');
            if (reviewBadge) {
                if (!reviewBadge.id) {
                    reviewBadge.id = `review_${uniqueId}`;
                }
                describedByIds.push(reviewBadge.id);
                
                const starsContainer = reviewBadge.querySelector('.jdgm-prev-badge__stars');
                if (starsContainer) {
                    starsContainer.removeAttribute('role');
                    starsContainer.removeAttribute('tabindex');
                    starsContainer.removeAttribute('aria-label');
                    const score = starsContainer.getAttribute('data-score');
                    if (score) {
                        const label = `${score} out of 5 stars`;
                        const hidden = starsContainer.querySelectorAll('.visually-hidden');
                        hidden.forEach((el, i) => i === 0 ? el.textContent = label : el.remove());
                        if (!hidden.length) {
                            const hiddenSpan = document.createElement('span');
                            hiddenSpan.classList.add('visually-hidden');
                            hiddenSpan.innerText = label;
                            starsContainer.prepend(hiddenSpan);
                        }
                    }
                }
            }
            
            if (describedByIds.length > 0) {
                const existingDescribedBy = titleLink.getAttribute('aria-describedby');
                const newDescribedBy = describedByIds.join(' ');
                if (existingDescribedBy) {
                    const existingIds = existingDescribedBy.split(' ');
                    const allIds = [...new Set([...describedByIds, ...existingIds])];
                    titleLink.setAttribute('aria-describedby', allIds.join(' '));
                } else {
                    titleLink.setAttribute('aria-describedby', newDescribedBy);
                }
            }
            
            product.dataset.extraInfoAccessibilityFixed = 'true';
        };
    }

    function getProductImageLink(product) {
        const exclusionSelectors = '.hover_button, .nt_add_qv, .pr_atc, .nt_add_cp';
        const prioritizedSelectors = [
            '.product-image a.db',
            '.product-image a[href]',
            '.product-inner a.db',
        ];

        for (const selector of prioritizedSelectors) {
            const match = product.querySelector(selector);
            if (match) {
                return match;
            }
        }

        const candidateLinks = Array.from(product.querySelectorAll('a[href]')).filter(link => !link.closest(exclusionSelectors));
        for (const link of candidateLinks) {
            if (link.querySelector('.pr_lazy_img, img')) {
                return link;
            }
        }

        return null;
    }

    const SLIDE_TOGGLE_CLASSES = ['slides-carousel-toggle', 'autograph-carousel-toggle', 'toggle-flicky-btn'];

    function isToggleSlide(slide) {
        if (!slide || !(slide instanceof Element)) return false;
        return SLIDE_TOGGLE_CLASSES.some(cls => slide.classList.contains(cls));
    }

    function applySlideGroupSemantics({ slider, slides, regionLabel, skipSlide }) {
        if (!slider || !slides) return 0;

        const validSlides = Array.from(slides).filter((slide) => {
            if (!(slide instanceof Element)) return false;
            if (typeof skipSlide === 'function' && skipSlide(slide)) {
                return false;
            }
            return true;
        });

        const totalSlides = validSlides.length;
         if (totalSlides <= 1) return 0;

        validSlides.forEach((slide, index) => {
            if (slide.getAttribute('role') !== 'group') {
                slide.setAttribute('role', 'group');
            }
            const ariaLabel = `Slide ${index + 1} of ${totalSlides}`;
            if (slide.getAttribute('aria-label') !== ariaLabel) {
                slide.setAttribute('aria-label', ariaLabel);
            }
        });

        slider.dataset.slideSemanticsTotal = String(totalSlides);

        return totalSlides;
    }

    //Not necessary

    // function ensureSlideRegionsFallback() {
    //     const markRegion = (el, totalSlides) => {
    //         if (!el || el.dataset.slideRegionSet === 'true') return;
    //         if (totalSlides <= 1) return;
    //         if (!el.getAttribute('role')) {
    //             el.setAttribute('role', 'region');
    //         }
    //         if (!el.getAttribute('aria-label') && totalSlides) {
    //             el.setAttribute('aria-label', `Carousel with ${totalSlides} slides`);
    //         }
    //         el.dataset.slideRegionSet = 'true';
    //     };

    //     const process = () => {
    //         const slideGroups = document.querySelectorAll('[role="group"][aria-label^="Slide "]');
    //         slideGroups.forEach((slide) => {
    //             const ariaLabel = slide.getAttribute('aria-label') || '';
    //             const matches = ariaLabel.match(/Slide\s+\d+\s+of\s+(\d+)/i);
    //             const totalSlides = matches ? parseInt(matches[1], 10) : null;
    //             const regions = [
    //                 slide.closest('.flickity-slider'),
    //                 // slide.closest('.flickity-viewport'),
    //                 // slide.closest('.js_carousel.nt_slider'),
    //                 // slide.closest('.nt_products_holder')
    //             ];
    //             regions.forEach((region) => markRegion(region, totalSlides));
    //         });
    //     };

    //     process();

    //     if (ensureSlideRegionsFallback.observer) return;
    //     ensureSlideRegionsFallback.observer = new MutationObserver(process);
    //     ensureSlideRegionsFallback.observer.observe(document.body, {
    //         childList: true,
    //         subtree: true
    //     });
    // }

    function roleRegionToSliders() {
        const sliders = document.querySelectorAll('.nt_products_holder, .nt_banner_holder');
        sliders.forEach((slide, index) => {
            const slideObserver = new MutationObserver(() => {
                const flickity = slide.querySelector('.flickity-slider')
                if (!flickity) return;
                if (slide.classList.contains('flickity-enabled') && !slide.closest('.tab_se_element')) {
                    flickity.setAttribute('role', 'region');
                    flickity.setAttribute('aria-description', 'Carousel');
                    const parent = slide.closest('.container');
                    const titleContainer = parent.querySelector('.section-title');
                    if (titleContainer) {
                        titleContainer.id = 'title_slide_' + index;
                        flickity.setAttribute('aria-labelledby', titleContainer.id);
                        const viewMoreBtn = parent.querySelector('.products-footer .view_more');
                        if(viewMoreBtn) {
                            viewMoreBtn.setAttribute('aria-describedby', titleContainer.id);
                        }
                    }
                }
                slideObserver.disconnect();
            });
            slideObserver.observe(slide, { subtree: true, childList: true })
        });
    }
    roleRegionToSliders();

    function applyProductListSemantics(container) {
        if (!container) return;

        const isSlider = container.classList.contains('flickity-enabled') ||
                         container.hasAttribute('data-flickity') ||
                         container.classList.contains('js_carousel') ||
                         container.querySelector('.flickity-slider');

        
        if (isSlider) return;

        if (!container.getAttribute('role')) {
            container.setAttribute('role', 'list');
        }

        const products = container.querySelectorAll('.pr_grid_item.product');
        products.forEach(product => {
            if (!product.getAttribute('role')) {
                product.setAttribute('role', 'listitem');
            }
        });

        container.dataset.listSemanticsSet = 'true';
    }

    function ensureProductListSemantics() {
        const process = () => {
            const containers = document.querySelectorAll('.products.nt_products_holder');
            containers.forEach(container => {
                applyProductListSemantics(container);
            });
        };

        process();

        if (ensureProductListSemantics.observer) return;
        ensureProductListSemantics.observer = new MutationObserver(process);
        ensureProductListSemantics.observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-hidden', 'class']
        });
    }

    function setupProductFocusFix({ shouldRun, containerSelector, datasetFlag, onContainerReady, onProductFixed }) {
        if (!shouldRun()) return;

        const productMarkupObservers = new WeakMap();
        const processedContainers = new WeakSet();

        function applyFocusFix(product, titleLink, imageLink) {
            if (!titleLink || !imageLink || product.dataset[datasetFlag] === 'true') return;

            if (!titleLink.id) {
                titleLink.id = `recently-viewed-title-${Math.random().toString(16).slice(2)}`;
            }
            const titleId = titleLink.id;

            // const h3Title = titleLink.closest('h3.product-title');
            // if (h3Title) {
            //     const div = document.createElement('div');
            //     div.className = h3Title.className + ' h3';
            //     div.innerHTML = h3Title.innerHTML;
            //     h3Title.replaceWith(div);
            // }

            replaceLinkWithSpan(imageLink, titleLink);
            const imageWrapper = product.querySelector('.product-image .db');
            if (imageWrapper && imageWrapper.tagName === 'SPAN') {
                imageWrapper.setAttribute('aria-hidden', 'true');
            }


            const href = titleLink.getAttribute('href');
            if (href) {
                // titleLink.removeAttribute('href');
                titleLink.setAttribute('href', titleLink.getAttribute('href')+'?')
                // titleLink.setAttribute('new_href', href)
                // titleLink.tabIndex = "0";
                // titleLink.setAttribute('role', 'link')
                // titleLink.style.cursor = 'pointer'
                // titleLink.addEventListener('click', () => {
                //     window.location.href = titleLink.getAttribute('new_href');
                // });
                // titleLink.addEventListener('keydown', (e) => {
                //     if (e.key === 'Enter') {
                //         window.location.href = titleLink.getAttribute('new_href');
                //     }
                // });
            }
            

            const isNonActionButton = (el) => el.classList.contains('read-more') || el.classList.contains('js__qs');

            const hoverButtons = product.querySelectorAll('.hover_button a:not(.js_add_qv), .hover_button span.wishlistadd, .hover_button span.wis_added');
            hoverButtons.forEach(btn => {
                if (btn.hasAttribute('href')) {
                    btn.removeAttribute('href');
                }
                btn.setAttribute('role', 'button');
                btn.style.cursor = 'pointer';
                btn.setAttribute('tabindex', '0');
                btn.setAttribute('aria-describedby', titleId);
            });

            const quickViewLink = product.querySelector('.hover_button .js_add_qv');
            if (quickViewLink && !quickViewLink.getAttribute('applied')) {
                quickViewLink.setAttribute('href', quickViewLink.getAttribute('href') + '/');
                quickViewLink.setAttribute('role', 'button');
                quickViewLink.setAttribute('aria-describedby', titleId);
                quickViewLink.setAttribute('applied', 'true');
            }

            const addToCartBtn = product.querySelector('.pr_atc:not(.read-more):not(.js__qs)');
            if (addToCartBtn) {
                // if (addToCartBtn.hasAttribute('href')) {
                //     addToCartBtn.setAttribute('href', addToCartBtn.getAttribute('href') + '/');
                //     // addToCartBtn.removeAttribute('href');
                // }
                addToCartBtn.setAttribute('tabindex', '0');
                addToCartBtn.setAttribute('role', 'button');
                addToCartBtn.style.cursor = 'pointer';
                addToCartBtn.setAttribute('aria-describedby', titleId);
            }

            const quickShopBtn = product.querySelector('.pr_atc.js__qs');
            if (quickShopBtn && quickShopBtn.dataset.redundantFixed !== 'true') {
                // if (quickShopBtn.hasAttribute('href')) {
                //     quickShopBtn.removeAttribute('href');
                //     quickShopBtn.setAttribute('href', addToCartBtn.getAttribute('href') + '/');
                //     // addToCartBtn.removeAttribute('href');
                // }
                quickShopBtn.setAttribute('role', 'button');
                quickShopBtn.setAttribute('tabindex', '0');
                quickShopBtn.style.cursor = 'pointer';
                quickShopBtn.setAttribute('aria-describedby', titleId);
                quickShopBtn.dataset.redundantFixed = 'true';
            }

            const readMoreBtn = product.querySelector('.pr_atc.read-more');
            if (readMoreBtn && readMoreBtn.dataset.redundantFixed !== 'true') {
                // readMoreBtn.removeAttribute('href');
                // readMoreBtn.setAttribute('role', 'link');
                // readMoreBtn.setAttribute('tabindex', '0');
                // readMoreBtn.style.cursor = 'pointer';
                readMoreBtn.setAttribute('aria-describedby', titleId);
                
                // readMoreBtn.addEventListener('click', (e) => {
                //     e.preventDefault();
                //     titleLink.click();
                // });
                
                // readMoreBtn.addEventListener('keydown', (e) => {
                //     if (e.key === 'Enter') {
                //         e.preventDefault();
                //         titleLink.click();
                //     }
                // });
                
                readMoreBtn.dataset.redundantFixed = 'true';
            }
            
            //Update aria label from links
            product.querySelectorAll('.nt_add_w > a:not([applied]), .nt_add_w > span:not([applied]), .nt_add_cp > a:not([applied]), .nt_add_cp > span:not([applied])').forEach(link => {
                link.setAttribute('applied', 'true');
                setTimeout(() => {
                    const text = link.querySelector('.tt_txt');
                    if (!text) return
                    const updateLabel = () => link.setAttribute('aria-label', text.textContent);
                    updateLabel();
                    link.addEventListener('click', () => {
                        setTimeout(() => updateLabel(), 300);
                    });
                    link.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') setTimeout(() => updateLabel(), 300);
                    });
                }, 200);
            });

            product.dataset[datasetFlag] = 'true';
            product.dataset.focusFixed = 'true';

            if (typeof window.fixProductPriceAccessibility === 'function') {
                window.fixProductPriceAccessibility(product);
            }

            if (typeof window.fixProductExtraInfoAccessibility === 'function') {
                const currentTitleLink = product.querySelector(`.product-title a[id="${titleId}"]`) || product.querySelector('.product-title a');
                if (currentTitleLink) {
                    const uniqueId = titleId.replace(/^(recently-viewed-title-|title_related_|best_title_appliances_|product_title_id_|feature-title-)/, '') || titleId;
                    window.fixProductExtraInfoAccessibility(product, currentTitleLink, uniqueId);
                }
            }

            if (typeof onProductFixed === 'function') {
                onProductFixed(product, { titleLink, imageLink });
            }
        }

        function ensureProductReady(product) {
            const titleLink = product.querySelector('.product-title a');
            const imageLink = getProductImageLink(product);

            if (titleLink && imageLink) {
                const existingObserver = productMarkupObservers.get(product);
                if (existingObserver) {
                    existingObserver.disconnect();
                    productMarkupObservers.delete(product);
                }
                applyFocusFix(product, titleLink, imageLink);
                return true;
            }

            if (!productMarkupObservers.has(product)) {
                const observer = new MutationObserver(() => {
                    const readyTitle = product.querySelector('.product-title a');
                    const readyImage = getProductImageLink(product);

                    if (readyTitle && readyImage) {
                        observer.disconnect();
                        productMarkupObservers.delete(product);
                        applyFocusFix(product, readyTitle, readyImage);
                    }
                });

                observer.observe(product, {
                    childList: true,
                    subtree: true
                });

                productMarkupObservers.set(product, observer);
            }

            return false;
        }

        function processProducts(container) {
            if (!container || !(container instanceof Element)) return;

            container.querySelectorAll('.product').forEach(product => {
                if (product.dataset[datasetFlag] === 'true') {
                    return;
                }
                ensureProductReady(product);
            });
        }

        const resolveContainers = () => {
            if (typeof containerSelector === 'function') {
                const result = containerSelector();
                if (Array.isArray(result)) {
                    return result.filter(Boolean);
                }
                return result ? [result] : [];
            }
            if (typeof containerSelector === 'string') {
                return Array.from(document.querySelectorAll(containerSelector));
            }
            return [];
        };

        function initialize() {
            const containers = resolveContainers().filter(container => !processedContainers.has(container));
            if (!containers.length) {
                return false;
            }

            containers.forEach(container => {
                processedContainers.add(container);

                if (typeof onContainerReady === 'function') {
                    onContainerReady(container);
                }

                processProducts(container);

                const containerObserver = new MutationObserver(() => {
                    processProducts(container);
                });

                containerObserver.observe(container, {
                    childList: true,
                    subtree: true
                });
            });

            return true;
        }

        if (initialize()) {
            const bodyObserver = new MutationObserver(() => {
                initialize();
            });

            bodyObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return;
        }

        const bodyObserver = new MutationObserver(() => {
            if (initialize()) {
                bodyObserver.disconnect();
            }
        });

        bodyObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function removeTabindexFromFlickityWrappers() {
        const sliderSelector = '[data-flickity]';
        const pendingSliderObservers = new WeakMap();

        const waitForSlides = (sliderEl) => {
            if (pendingSliderObservers.has(sliderEl)) {
                return;
            }

            const waitObserver = new MutationObserver(() => {
                const updatedCount = sliderEl.querySelectorAll('.flickity-slider > *').length;
                if (updatedCount > 1) {
                    waitObserver.disconnect();
                    pendingSliderObservers.delete(sliderEl);
                    processSlider(sliderEl);
                }
            });

            waitObserver.observe(sliderEl, {
                childList: true,
                subtree: true
            });

            pendingSliderObservers.set(sliderEl, waitObserver);
        };

        const processSlider = (sliderEl) => {
            if (!(sliderEl instanceof Element)) return;

            const slideCount = sliderEl.querySelectorAll('.flickity-slider > *').length;
            if (slideCount <= 1) {
                waitForSlides(sliderEl);
                return;
            }

            if (pendingSliderObservers.has(sliderEl)) {
                pendingSliderObservers.get(sliderEl)?.disconnect();
                pendingSliderObservers.delete(sliderEl);
            }

            const cleanup = () => {
                if (sliderEl.hasAttribute('tabindex')) {
                    sliderEl.removeAttribute('tabindex');
                }
            };

            cleanup();

            if (sliderEl.dataset.flickityWrapperTabFix === 'true') {
                return;
            }

            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.attributeName === 'tabindex') {
                        cleanup();
                    }
                }
            });

            observer.observe(sliderEl, {
                attributes: true,
                attributeFilter: ['tabindex']
            });

            sliderEl.dataset.flickityWrapperTabFix = 'true';
        };

        const scanForSliders = (root) => {
            if (root instanceof Element && root.matches(sliderSelector)) {
                processSlider(root);
            }
            if (!root.querySelectorAll) return;
            root.querySelectorAll(sliderSelector).forEach(processSlider);
        };

        scanForSliders(document);

        if (removeTabindexFromFlickityWrappers.observer) {
            return;
        }

        removeTabindexFromFlickityWrappers.observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'attributes') {
                    const target = mutation.target;
                    if (target instanceof Element && target.matches(sliderSelector)) {
                        processSlider(target);
                    }
                    continue;
                }

                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (!(node instanceof Element)) return;
                        scanForSliders(node);
                    });
                }
            }
        });

        removeTabindexFromFlickityWrappers.observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-flickity']
        });
    }

    removeTabindexFromFlickityWrappers();

    function fixReviews() {
        if (!window.location.pathname.includes('/products')) return;
        const container = document.querySelector('.jdgm-rev-widg');

        if (!container) return;

        const updateReviewList = () => {
            const reviewsSection = container.querySelector('.jdgm-rev-widg__reviews');
            reviewsSection.querySelectorAll('.jdgm-rev').forEach(review => {
                fixReviewItem(review);
            });

        };

        fixBadges(container);
        fixRatingSection(container);
        fixAverage(container);
        updateReviewList();
        fixCountdown(container);
        fixEmailValidationMessage(container);
        fixNotificationAlert(container);
        focusFirstErrorOnSubmit(container);
        fixAskQuestionForm(container);
        tabListToReviewsQuestions(container);
        paginationSemantics(container);
        fixQuestionsSection(container);
        focusStarFirst(container);

        function focusStarFirst(container) {
            const observerReviewBtn = new MutationObserver(() => {
                const reviewBtn = container.querySelector('.jdgm-write-rev-link');
                if(reviewBtn) {
                    reviewBtn.addEventListener('click', () => {
                        setTimeout(() => {
                            const stars = container.querySelectorAll('.jdgm-form__fieldset a.jdgm-star');
                            if(stars.length > 0) {
                                stars[0].focus()
                            }
                        }, 200);
                    });

                    reviewBtn.addEventListener('click', (e) => {
                        if(e.key === 'Enter') {
                            e.preventDefault();
                            reviewBtn.click();
                        }
                    })

                observerReviewBtn.disconnect();
                }
            });

            observerReviewBtn.observe(container, {
                subtree: true,
                childList: true
            })
        }

        function paginationSemantics(container) {
            const observe = (paginationObserver) => {
                paginationObserver.observe(container, {
                    subtree: true,
                    childList: true
                });
            };
            
            const paginationObserver = new MutationObserver(() => {
                const pagination = container.querySelector('.jdgm-paginate');
                if(!pagination) return;
                paginationObserver.disconnect();
                pagination.setAttribute('role', 'navigation');
                pagination.setAttribute('aria-label', 'Pagination');
                const pages = pagination.querySelectorAll(
                '.jdgm-paginate__page:not(.jdgm-paginate__next-page):not(.jdgm-paginate__last-page)'
                );
                pages.forEach(page => {
                    page.setAttribute('aria-current', page.classList.contains('jdgm-curt'));
                    page.addEventListener('click', () => observe(paginationObserver));
                    page.addEventListener('keydown', (e) => {
                        if(e.key === 'Enter') observe(paginationObserver);
                    });
                });

                pagination.querySelectorAll('.jdgm-paginate__next-page, .jdgm-paginate__prev-page').forEach(page => {
                    page.setAttribute('tabindex', '-1');
                    page.setAttribute('aria-hidden', 'true');
                });
            })

            observe(paginationObserver);
        }

        function tabListToReviewsQuestions(container) {
            const tabsObserver = new MutationObserver(() => {
                const tabsContainer = container.querySelector('.jdgm-subtab');
                if(!tabsContainer) return;
                const tabs = Array.from(tabsContainer.querySelectorAll('.jdgm-subtab__name'));

                // Add tablist role
                tabsContainer.setAttribute('role', 'tablist');

                tabs.forEach((tab, index) => {
                    tab.setAttribute('role', 'tab');

                    const isActive = tab.classList.contains('jdgm--active');

                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.tabIndex = isActive ? 0 : -1;

                    // Assign an ID if none exists (required for tabpanel linking)
                    if (!tab.id) tab.id = `jdgm-tab-${index}`;

                    // Create aria-controls if missing (safe fallback)
                    if (!tab.hasAttribute('aria-controls')) {
                    tab.setAttribute('aria-controls', `jdgm-tabpanel-${index}`);
                    }

                    // Handle click activation
                    tab.addEventListener('click', () => activateTab(tab));

                    // Keyboard navigation
                    tab.addEventListener('keydown', e => {
                    const curr = tabs.indexOf(tab);
                    let next = null;

                    if (e.key === 'ArrowRight') {
                        next = tabs[curr + 1] || tabs[0];
                    } else if (e.key === 'ArrowLeft') {
                        next = tabs[curr - 1] || tabs[tabs.length - 1];
                    } else if (e.key === 'Home') {
                        next = tabs[0];
                    } else if (e.key === 'End') {
                        next = tabs[tabs.length - 1];
                    } else if (e.key === 'Enter' || e.key === ' ') {
                        activateTab(tab);
                    }

                    if (next) {
                        e.preventDefault();
                        next.focus();
                    }
                    });
                });

                function activateTab(selected) {
                    tabs.forEach(tab => {
                    const isSelected = tab === selected;
                    tab.classList.toggle('jdgm--active', isSelected);
                    tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                    tab.tabIndex = isSelected ? 0 : -1;
                    });
                }

                tabsObserver.disconnect();
            });

            tabsObserver.observe(container, {
                subtree: true,
                childList: true
            })
        }

        function fixReviewItem(item) {
            item.setAttribute('role', 'group');
            const reviewId = item.getAttribute('data-review-id');
            const userContainer = item.querySelector('.jdgm-rev__author-wrapper');
            userContainer.id = reviewId;
            item.setAttribute('aria-labelledby', userContainer.id);
            const icon = item.querySelector('.jdgm-rev__icon');
            if (icon) {
                icon.setAttribute('aria-hidden', 'true');
            }

            const rating = item.querySelector('.jdgm-rev__rating');
            if (rating) {
                const value = rating.getAttribute('data-score');
                rating.setAttribute('aria-label', `${value} out of 5 stars`);
            }

            listenToThumbsUp(item);

            function listenToThumbsUp(item) {
                const observer = new MutationObserver(() => {
                    const voteContainer = item.querySelector('.jdgm-rev__votes-inner');
                    if (voteContainer) {
                        const username = userContainer.querySelector('.jdgm-rev__author').innerText;
                        const voteNumbers = voteContainer.querySelectorAll('.jdgm-rev__thumb-count');
                        voteContainer.querySelectorAll('.jdgm-rev__thumb-btn').forEach((voteBtn, index) => {
                            voteBtn.setAttribute('role', 'button');
                            voteBtn.removeAttribute('title');
                            voteNumbers[index].id = `vote_${index}_${reviewId}`;

                            const isPositive = voteBtn.classList.contains('jdgm-rev_thumb-up');
                            voteBtn.setAttribute('aria-label', `${username}'s review ${isPositive ? 'was' : 'was not'} helpful`);
                            voteBtn.setAttribute('aria-describedby', voteNumbers[index].id);

                            const oldValue = voteNumbers[index].innerText;

                            const verifyPress = () => {
                                setTimeout(() => {
                                    const newValue = voteNumbers[index].innerText;
                                    if (newValue !== oldValue) {
                                        voteBtn.setAttribute('aria-pressed', 'true');
                                    }
                                }, 500);

                            }
                            voteBtn.addEventListener('click', verifyPress);
                            voteBtn.addEventListener('keydown', (e) => {
                                if (e.key === 'Enter') {
                                    verifyPress();
                                }
                            });
                        });

                        observer.disconnect();
                    }
                });

                observer.observe(item, {
                    subtree: true,
                    childList: true
                });
            }


        }

        function fixRatingSection(container) {
            const list = container.querySelector('.jdgm-histogram');
            if (!list) return;

            list.setAttribute('role', 'list');
            list.setAttribute('aria-label', 'Ratings Distribution');
            list.querySelectorAll('.jdgm-histogram__row').forEach(row => {
                row.setAttribute('role', 'listitem');
                row.querySelectorAll('.jdgm-histogram__bar, .jdgm-histogram__frequency').forEach(el => {
                    el.setAttribute('aria-hidden', 'true');
                })
            });
        }

        function fixBadges(container) {
            const badgeContainer = container.querySelector('.jdgm-medals .jdgm-medals__container');
            if (!badgeContainer) return;

            badgeContainer.setAttribute('aria-label', 'Judge.me badges');
            badgeContainer.setAttribute('role', 'list');
            badgeContainer.querySelectorAll('.jdgm-medal-wrapper').forEach(badge => {
                badge.setAttribute('role', 'listitem');
                badge.removeAttribute('title');
            })
        }

        function fixAverage(container) {
            const average = container.querySelector('.jdgm-rev-widg__summary-stars');
            if(!average) return;
            average.removeAttribute('aria-label');
            average.removeAttribute('role');
            average.querySelectorAll('.jdgm-star').forEach(star => {
                star.setAttribute('aria-hidden', 'true');
            })
        }

        function fixCountdown(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const countdowns = formWrapper.querySelectorAll('.jdgm-countdown');

                    countdowns.forEach((countdown, index) => {
                        if (countdown.hasAttribute('data-countdown-fixed')) return;
                        countdown.setAttribute('data-countdown-fixed', 'true');
                        countdown.id = `countdown_`+index;

                        const formFieldContainer = countdown.closest('.jdgm-form__fieldset');
                        if(formFieldContainer) {
                            const field = formFieldContainer.querySelector('input, textarea');
                            if(field) {
                                field.setAttribute('aria-describedby', countdown.id);
                            }
                        }

                        const observer = new MutationObserver(() => {
                            if (countdown.textContent.trim() && !countdown.querySelector('.visually-hidden')) {
                                const hiddenSpan = document.createElement('span');
                                hiddenSpan.className = 'visually-hidden';
                                hiddenSpan.textContent = ' characters remaining';
                                countdown.appendChild(hiddenSpan);
                            }
                        });

                        observer.observe(countdown, {
                            childList: true,
                            characterData: true,
                            subtree: true
                        });

                        if (countdown.textContent.trim() && !countdown.querySelector('.visually-hidden')) {
                            const hiddenSpan = document.createElement('span');
                            hiddenSpan.className = 'visually-hidden';
                            hiddenSpan.textContent = ' characters remaining';
                            countdown.appendChild(hiddenSpan);
                        }
                    });
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true,
                attributes: true
            });
        }

        function fixAskQuestionForm(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-question-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const titleAskQuestion = container.querySelector('.jdgm-question-form-wrapper div.jdgm-form__title');
                    if(titleAskQuestion) {
                        const h3 = document.createElement('h3');
                        h3.innerText = titleAskQuestion.innerText;
                        h3.className = titleAskQuestion.className;
                        titleAskQuestion.replaceWith(h3);
                    }

                    const nameInput = container.querySelector('#jdgm_question_reviewer_name:not([autocomplete])');
                    if(nameInput) {
                        nameInput.setAttribute('autocomplete', 'name')
                        // nameInput.setAttribute('aria-required', 'true')
                    }

                    const emailInput = container.querySelector('#jdgm_question_reviewer_email:not([autocomplete])');
                    if(emailInput) {
                        emailInput.setAttribute('autocomplete', 'email')
                        // emailInput.setAttribute('aria-required', 'true')
                    }
                    const formContainer = container.querySelector('.jdgm-question-form:not([applied])')
                    if(formContainer) {
                        formContainer.querySelectorAll('label').forEach(label => {
                            label.innerText = label.innerText + '*'
                        });
                        // const questionTextArea = container.querySelector('#jdgm_question_content');
                        // if(questionTextArea) {
                        //     questionTextArea.setAttribute('aria-required', 'true')
                        // }
                        formContainer.setAttribute('applied', 'true');
                    }
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style']
            });
        } 


        function fixEmailValidationMessage(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const form = formWrapper.querySelector('form:not([applied])');
                    if(form) {
                        form.setAttribute('applied', 'true');
                        form.querySelectorAll('input[name="reviewer_name"], input[name="reviewer_email"]').forEach(input => {
                            const parent = input.parentNode;
                            const label = parent.querySelector('p');
                            label.innerText = label.innerText+'*';

                            if(input.getAttribute('reviewer_name')) {
                                input.setAttribute('autocomplete', 'name');
                                input.setAttribute('aria-required', 'true');
                            } else {
                                input.setAttribute('autocomplete', 'email');
                                input.setAttribute('aria-required', 'true');
                            }
                        });
                        const textarea = form.querySelector('textarea');
                        textarea.setAttribute('aria-required', 'true');
                        const parent = textarea.closest('.jdgm-form__fieldset');
                        const label = parent.querySelector('p');
                        label.innerText = label.innerText + '*';

                        const stars = form.querySelector('.jdgm-form__fieldset:has(.jdgm-star)');
                        const labelStars = stars.querySelector('p');
                        labelStars.innerText = labelStars.innerText + '*';
                        
                        const fileInput = document.querySelector('input[type="file"]');
                        if(fileInput) {
                            fileInput.title = '';
                        }

                        new MutationObserver(()=> {
                            const deleteBtn = form.querySelector('.jdgm-picture-fieldset__delete');
                            if(deleteBtn) {
                                deleteBtn.setAttribute('aria-label', 'Remove media');
                                deleteBtn.setAttribute('role', 'button');
                                deleteBtn.setAttribute('tabindex', '0');
                            }
                        }).observe(form, {subtree: true, childList: true});

                        makeStarsRadioGroup(form);
                    }

                    const titleAskQuestion = formWrapper.querySelector('h2.jdgm-form__title');
                    if (titleAskQuestion) {
                        const h3 = document.createElement('h3');
                        h3.innerText = titleAskQuestion.innerText;
                        h3.className = titleAskQuestion.className;
                        titleAskQuestion.replaceWith(h3);
                    }

                    const emailFieldset = formWrapper.querySelector('.jdgm-form__email-fieldset');
                    if (!emailFieldset) return;

                    if (emailFieldset.hasAttribute('data-email-error-fixed')) return;
                    emailFieldset.setAttribute('data-email-error-fixed', 'true');

                    const emailInput = emailFieldset.querySelector('input[type="email"]');
                    if (!emailInput) return;

                    const applyMessage = () => {
                        const describedBy = emailInput.getAttribute('aria-describedby');
                        let errorElement = null;

                        if (describedBy) {
                            errorElement = document.getElementById(describedBy);
                        }

                        if (!errorElement) {
                            errorElement = emailFieldset.querySelector('.jdgm-input-error');
                        }

                        if (errorElement && errorElement.textContent.trim() === 'Please enter a valid email address.') {
                            errorElement.textContent = 'Please enter a valid email address in the format user@example.com';
                        }
                    };

                    applyMessage();

                    const observer = new MutationObserver(() => {
                        applyMessage();
                    });

                    observer.observe(emailFieldset, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['class', 'aria-invalid', 'aria-describedby']
                    });
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style']
            });
        }

        function makeStarsRadioGroup(container) {
            const stars = Array.from(container.querySelectorAll('.jdgm-star'));
            const input = container.querySelector('input[name="score"]');

            if(!stars.length) return;
            container.setAttribute('role', 'radiogroup');

            const parent = stars[0].parentNode;
            if(parent) {
                parent.className = parent.className+"2";
            }

            // Init stars
            stars.forEach((star, index) => {
                star.setAttribute('role', 'radio');
                star.setAttribute('tabindex', index === 0 ? '0' : '-1');
                star.setAttribute('aria-checked', 'false');
                star.removeAttribute('title');

                // Mouse
                star.addEventListener('click', () => {
                    select(index, { focus: false });
                });

                // Keyboard
                star.addEventListener('keydown', e => {
                    switch (e.key) {
                        case 'Enter':
                        case ' ':
                            e.preventDefault();
                            select(index);
                            break;
                        case 'ArrowRight':
                            move(index + 1);
                            break;
                        case 'ArrowLeft':
                            move(index - 1);
                            break;
                    }
                });
            });

            function select(i, { focus = true } = {}) {
                if (i < 0 || i >= stars.length) return;

                stars.forEach((star, idx) => {
                    const isOn = idx <= i;
                    const isSelected = idx === i;

                    star.classList.toggle('jdgm--on', isOn);
                    star.classList.toggle('jdgm--off', !isOn);
                    star.setAttribute('aria-checked', isSelected ? 'true' : 'false');
                    star.tabIndex = isSelected ? 0 : -1;
                });

                if (focus) {
                    stars[i].focus();
                }
                
                const parent = stars[0].parentNode;
                if(parent) {
                    parent.querySelector('input').setAttribute('aria-invalid', parent.querySelectorAll('a.jdgm--on').length ? 'false' : 'true');
                }
                input.value = stars[i].dataset.alt;
            }

            function move(i) {
                if (i < 0 || i >= stars.length) return;

                stars.forEach(s => (s.tabIndex = -1));
                stars[i].tabIndex = 0;
                stars[i].focus();
            }
        }


        function fixNotificationAlert(container) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && node.classList.contains('jdgm-notification')) {
                            const titleElement = node.querySelector('.jdgm-notification__title');
                            if (titleElement && !titleElement.hasAttribute('data-alert-role-added')) {
                                titleElement.setAttribute('role', 'alert');
                                titleElement.setAttribute('data-alert-role-added', 'true');
                            }
                        }
                    });
                });
            });

            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }

        function focusFirstErrorOnSubmit(container) {
            const formObserver = new MutationObserver(() => {
                const formWrapper = container.querySelector('.jdgm-form-wrapper');
                if (formWrapper && formWrapper.style.display !== 'none') {
                    const form = formWrapper.querySelector('.jdgm-form');
                    if (!form || form.hasAttribute('data-focus-error-attached')) return;

                    form.setAttribute('data-focus-error-attached', 'true');

                    form.addEventListener('submit', () => {
                        setTimeout(() => {
                            const errors = form.querySelectorAll('[aria-invalid="true"]');
                            if (errors.length > 0) {
                                const field = errors[0];
                                //Changed the class for stars to stop listening to the library star update
                                const fieldset = field.closest('.jdgm-form__rating2');
                                if(fieldset) {
                                    fieldset.querySelector('input').setAttribute('aria-invalid', fieldset.querySelectorAll('a.jdgm--on').length ? 'false' : 'true');
                                    const firstStar = fieldset.querySelector('a');
                                    if(firstStar) {
                                        firstStar.focus();
                                    }
                                    
                                    
                                } else {
                                    field.focus();
                                }
                                
                            }
                        }, 150);
                    });
                }
            });

            formObserver.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style']
            });
        }

        function fixQuestionsSection(container) {
            const observer = new MutationObserver((mutations) => {
                const questionsContainer = container.querySelector('.jdgm-quest-widg__body');
                if(!questionsContainer) return;

                questionsContainer.querySelectorAll('.jdgm-quest').forEach((item, index) => {
                    item.setAttribute('role', 'group');
                    const author = item.querySelector('.jdgm-rev__author');
                    if(author) {
                        author.id = `quest_${index}`;
                        item.setAttribute('aria-labelledby', author.id)
                    }

                    const profile = item.querySelector('.jdgm-rev__icon');
                    if(profile) {
                        profile.setAttribute('aria-hidden', 'true');
                    }
                });
            });

            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }

    }

    fixReviews();

    function fixCartButtonFlashes() {
        const cartButton = document.querySelector('.single_add_to_cart_button.js_frm_cart');
        
        if (!cartButton) {
            const observer = new MutationObserver(() => {
                const btn = document.querySelector('.single_add_to_cart_button.js_frm_cart');
                if (btn) {
                    observer.disconnect();
                    setupCartButtonFix(btn);
                }
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            return;
        }
        
        setupCartButtonFix(cartButton);
        
        function setupCartButtonFix(button) {
            if (button.hasAttribute('data-time')) {
                button.removeAttribute('data-time');
            }
            if (button.hasAttribute('data-ani')) {
                button.removeAttribute('data-ani');
            }
            
            button.classList.remove('animated', 'undefined');
            
            const classObserver = new MutationObserver(() => {
                if (button.classList.contains('animated') || button.classList.contains('undefined')) {
                    button.classList.remove('animated', 'undefined');
                }
            });
            
            classObserver.observe(button, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    fixCartButtonFlashes();

    function fixProductSlidersFocus() {
        const sliderSelector = '.js_carousel.nt_slider[data-flickity]';

        // const debugSliderLog = (message, data) => {
        //     console.debug('[a11y-slider]', message, data);
        // };

        const getFocusableElements = (container) => Array.from(
            container.querySelectorAll(
                'a[href], a[role="button"], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex], [role="button"]'
            )
        ).filter((element) => !element.disabled && element.dataset.sliderDummyLink !== 'true');

            const ensureImageLinkConverted = (slide, isActive) => {
                const imageWrapper = slide.querySelector('.product-image');
                if (!imageWrapper) return;

                const convertLink = () => {
                let spanLink = imageWrapper.querySelector('span.db');
                const link = imageWrapper.querySelector('a.db');

                    if (!spanLink && link) {
                        const href = link.getAttribute('href') || '#';
                        const target = link.getAttribute('target') || '_self';
                        
                        const dummyTrigger = document.createElement('span');
                        dummyTrigger.style.display = 'none';
                        dummyTrigger.dataset.sliderDummyTrigger = 'true';
                        dummyTrigger.dataset.href = href;
                        dummyTrigger.dataset.target = target;
                        
                        dummyTrigger.click = function() {
                            if (target === '_blank') {
                                window.open(href, '_blank');
                            } else {
                                window.location.href = href;
                            }
                        };
                        
                        if (typeof window.replaceLinkWithSpan === 'function') {
                            window.replaceLinkWithSpan(link, dummyTrigger);
                            slide.appendChild(dummyTrigger);
                            spanLink = imageWrapper.querySelector('span.db');
                        } else {
                            const span = document.createElement('span');
                            if (typeof window.copyAttributes === 'function') {
                                window.copyAttributes(link, span);
                            }
                            span.innerHTML = link.innerHTML;
                            span.setAttribute('aria-hidden', 'true');
                            link.replaceWith(span);
                            spanLink = span;
                        }
                        // replaceLinkWithSpan2nd(link, dummyTrigger);
                        //     slide.appendChild(dummyTrigger);
                        //     spanLink = imageWrapper.querySelector('span.db');
                    }

                if (spanLink) {
                    spanLink.setAttribute('aria-hidden', 'true');
                    if (!isActive) {
                        spanLink.setAttribute('tabindex', '-1');
                    } else if (spanLink.getAttribute('tabindex') === '-1') {
                        spanLink.removeAttribute('tabindex');
                    }
                }
            };

            convertLink();

            if (!imageWrapper.dataset.sliderImageObserver) {
                const observer = new MutationObserver(() => {
                    convertLink()
                });
                observer.observe(imageWrapper, {
                    childList: true,
                    subtree: true
                });
                imageWrapper.dataset.sliderImageObserver = 'true';
            }
        };

        const processSlider = (slider) => {
            if (!slider) return;

            const tabWrapper = slider.closest('.tab_se_element');

            const updateSlides = () => {
                const tabInactive = (() => {
                    if (!tabWrapper) return false;
                    if (tabWrapper.classList.contains('ct_active')) return false;
                    const ariaHidden = tabWrapper.getAttribute('aria-hidden');
                    if (ariaHidden === 'true') return true;
                    if (ariaHidden === 'false') return false;
                    if (typeof window.getComputedStyle === 'function') {
                        const styles = window.getComputedStyle(tabWrapper);
                        if (styles.display === 'none' || styles.visibility === 'hidden') return true;
                    }
                    return false;
                })();
                const slides = slider.querySelectorAll('.flickity-slider > *');
                const totalSlides = applySlideGroupSemantics({
                    slider,
                    slides,
                    skipSlide: isToggleSlide
                });
                const debugData = {
                    tabInactive,
                    activeSlides: [],
                    totalSlides: totalSlides || slides.length
                };
                    // console.log('SLIDEs', slides)
                slides.forEach(slide => {
                    if (isToggleSlide(slide)) {
                        return;
                    }
                    const isActive = !tabInactive && slide.classList.contains('is-selected');

                    ensureImageLinkConverted(slide, isActive);

                    if (isActive) {
                        slide.removeAttribute('aria-hidden');
                        slide.removeAttribute('tabindex');
                    } else {
                        slide.setAttribute('aria-hidden', 'true');
                        slide.setAttribute('tabindex', '-1');
                    }

                    const focusables = getFocusableElements(slide);
                    focusables.forEach(element => {
                        if (isActive) {
                            const originalValue = element.dataset.sliderOriginalTabindex;
                            if (originalValue && originalValue !== 'none') {
                                element.setAttribute('tabindex', originalValue);
                            } else {
                                element.setAttribute('tabindex', '0');
                            }
                            delete element.dataset.sliderOriginalTabindex;
                            element.removeAttribute('aria-hidden');
                        } else {
                            if (!element.dataset.sliderOriginalTabindex) {
                                element.dataset.sliderOriginalTabindex = element.hasAttribute('tabindex')
                                    ? element.getAttribute('tabindex')
                                    : 'none';
                            }
                            element.setAttribute('tabindex', '-1');
                            element.setAttribute('aria-hidden', 'true');
                        }
                    });

                    if (isActive) {
                        const labelNode = slide.querySelector('.product-title, .product-info, h3, h4');
                        const label = labelNode ? labelNode.textContent.trim().slice(0, 80) : '';
                        const focusableDetails = getFocusableElements(slide).map(el => ({
                            tag: el.tagName.toLowerCase(),
                            classes: el.className || '',
                            tabindex: el.getAttribute('tabindex') || '',
                            ariaHidden: el.getAttribute('aria-hidden') || '',
                            text: (el.textContent || '').trim().slice(0, 50)
                        }));
                        debugData.activeSlides.push({
                            label,
                            focusables: focusableDetails
                        });
                    }
                });

                // debugSliderLog('updateSlides', debugData);
            };

            updateSlides();

            if (slider.dataset.sliderFocusListeners === 'true') return;

            slider.addEventListener('change.flickity', () => {
                setTimeout(updateSlides, 0);
            });

            slider.addEventListener('focusin', () => {
                updateSlides();
            });

            const navButtons = slider.querySelectorAll('.flickity-button');
            navButtons.forEach(btn => {
                const triggerUpdate = () => setTimeout(updateSlides, 300);
                btn.addEventListener('click', triggerUpdate);
                btn.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        triggerUpdate();
                    }
                });
            });

            const sliderObserver = new MutationObserver((mutations) => {
                if (mutations.some(mutation => mutation.type === 'attributes' || mutation.type === 'childList')) {
                    updateSlides();
                }
            });

            sliderObserver.observe(slider, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: ['class']
            });

            // if (tabWrapper && !tabWrapper.dataset.sliderFocusObserver) {
            //     const tabObserver = new MutationObserver(() => {
            //         updateSlides();
            //         setTimeout(updateSlides, 0);
            //     });
            //     tabObserver.observe(tabWrapper, {
            //         attributes: true,
            //         attributeFilter: ['class', 'aria-hidden', 'style']
            //     });
            //     tabWrapper.dataset.sliderFocusObserver = 'true';
            // }

            slider.dataset.sliderFocusListeners = 'true';
            slider.dataset.sliderFocusFixed = 'true';
        };

        const run = () => {
            const sliders = document.querySelectorAll(sliderSelector);
            if (!sliders.length) return false;
            sliders.forEach(processSlider);
            return true;
        };

        run();

        if (!fixProductSlidersFocus.observer) {
            const observer = new MutationObserver(() => run());

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            fixProductSlidersFocus.observer = observer;
        }
    }

    fixProductSlidersFocus();


    function fixQuickViewSlider() {
        // Function to fix Flickity pagination dots accessibility for quick view
        function fixFlickityDots(carousel) {
            const dotsList = carousel.querySelector('.flickity-page-dots');
            if (!dotsList) return;

            if (!dotsList.dataset.dotsFixed) {
                dotsList.setAttribute('role', 'none');
                dotsList.dataset.dotsFixed = 'true';
            }

            const dots = dotsList.querySelectorAll('.dot');
            const totalDots = dots.length;

            dots.forEach((dot, index) => {
                if (!dot.dataset.dotSetup) {
                    dot.setAttribute('tabindex', '0');
                    dot.setAttribute('role', 'button');
                    dot.setAttribute('aria-label', `Slide ${index + 1} of ${totalDots}`);

                    dot.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            dot.click();
                        }
                    });
                    dot.dataset.dotSetup = 'true';
                }

                const isSelected = dot.classList.contains('is-selected');
                if (isSelected) {
                    if (dot.getAttribute('aria-current') === 'step') {
                        dot.removeAttribute('aria-current');
                    }
                    dot.setAttribute('aria-current', 'true');
                } else {
                    dot.removeAttribute('aria-current');
                }
            });
        }

        // Function to process all slides
        function processAllSlides(carousel) {
            const children = carousel.querySelectorAll('.flickity-viewport .flickity-slider > *');
            const totalSlides = applySlideGroupSemantics({
                slider: carousel,
                slides: children
            });
            if (!totalSlides) return;

            //NOT NECCESARY
            // children.forEach((slide, index) => {
            //     const isVisible = slide.classList.contains('is-selected');
            //     const slideNum = index + 1;
            //     const labelText = `Slide ${slideNum} of ${totalSlides}`;

            //     if (!slide.dataset.slideLabel) {
            //         const label = document.createElement('span');
            //         label.className = 'sr-only';
            //         label.setAttribute('data-slide-label', 'true');
            //         slide.appendChild(label);
            //         slide.dataset.slideLabel = 'true';
            //     }

            //     const existingLabel = slide.querySelector('span.sr-only[data-slide-label="true"]');
            //     if (existingLabel && existingLabel.textContent !== labelText) {
            //         existingLabel.textContent = labelText;
            //     }

            //     if (isVisible) {
            //         slide.removeAttribute('aria-hidden');
            //         slide.removeAttribute('tabindex');
            //     } else {
            //         slide.setAttribute('aria-hidden', 'true');
            //         slide.setAttribute('tabindex', '-1');
            //     }
            // });

            const prevBtn = carousel.querySelector('.flickity-prev-next-button.previous');
            const nextBtn = carousel.querySelector('.flickity-prev-next-button.next');
            if (prevBtn && !prevBtn.dataset.ariaLabel) {
                prevBtn.setAttribute('aria-label', 'Previous slide');
                prevBtn.dataset.ariaLabel = 'true';
            }
            if (nextBtn && !nextBtn.dataset.ariaLabel) {
                nextBtn.setAttribute('aria-label', 'Next slide');
                nextBtn.dataset.ariaLabel = 'true';
            }
        }

        function processQuickViewCarousel(carousel) {
            if (carousel.dataset.qvAccessibilityProcessed) {
                return;
            }

            const viewport = carousel.querySelector('.flickity-viewport');
            if (!viewport) {
                return;
            }

            // Initial processing
            processAllSlides(carousel);
            fixFlickityDots(carousel);

            // Listen for Flickity changes
            carousel.addEventListener('change.flickity', () => {
                processAllSlides(carousel);
                fixFlickityDots(carousel);
            });

            // Also listen for DOM changes
            const observer = new MutationObserver(() => {
                processAllSlides(carousel);
                fixFlickityDots(carousel);
            });

            observer.observe(carousel, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });

            carousel.dataset.qvAccessibilityProcessed = 'true';
        }

        function tryProcessQuickView() {
            const quickViewSliders = document.querySelectorAll('.nt_carousel_qv[data-flickity]');
            
            if (quickViewSliders.length === 0) return false;

            let processedAny = false;
            quickViewSliders.forEach((carousel) => {
                if (!carousel.dataset.qvAccessibilityProcessed) {
                    processQuickViewCarousel(carousel);
                    processedAny = true;
                }
            });

            return processedAny;
        }

        // Try processing immediately
        if (tryProcessQuickView()) {
            return;
        }

        // If not found, observe for when quick view appears
        const observer = new MutationObserver(() => {
            tryProcessQuickView();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixQuickViewSlider();

    function fixAutographBundleSliders() {
        document.querySelectorAll('.js_carousel.nt_slider').forEach(slider => {
            slider.dataset.autographAccessibilityProcessed = '';
        });

        const E_HOVER_IN = ['mouseenter', 'mouseover'];
        const E_HOVER_OUT = ['mouseleave', 'mouseout'];
        const ALL_HOVER = [...E_HOVER_IN, ...E_HOVER_OUT];

        function processCarousel(carousel) {
            const viewport = carousel.querySelector('.flickity-viewport');
            if (!viewport) {
                return false;  // Return false to let observer retry
            }

            let flickityData;
            try {
                const rawData = carousel.getAttribute('data-flickity');
                flickityData = JSON.parse(rawData || '{}');
            } catch (error) {
                console.error('ERROR: Failed to parse data-flickity:', error);
                return false;
            }

            // Function to fix Flickity pagination dots accessibility
            function fixFlickityDots() {
                const dotsList = carousel.querySelector('.flickity-page-dots');
                if (!dotsList) return;

                if (!dotsList.dataset.dotsFixed) {
                    dotsList.dataset.dotsFixed = 'true';
                }

                const dots = dotsList.querySelectorAll('.dot');
                const totalDots = dots.length;

                dots.forEach((dot, index) => {
                    if (!dot.dataset.dotSetup) {
                        dot.removeAttribute('aria-label')
                        const span = document.createElement('span');
                        span.setAttribute('tabindex', '0');
                        span.setAttribute('role', 'button');
                        span.setAttribute('aria-label', `Slide ${index + 1} of ${totalDots}`);

                        span.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                dot.click();
                            }
                        });

                        span.addEventListener('click', () => dot.click());

                        dot.appendChild(span);

                        // Add MutationObserver to watch for aria-current changes by Flickity
                        const ariaObserver = new MutationObserver((mutations) => {
                            mutations.forEach((mutation) => {
                                if (mutation.type === 'attributes' && mutation.attributeName === 'aria-current') {
                                    const currentValue = dot.getAttribute('aria-current');
                                    if (currentValue === 'step') {
                                        dots.forEach(item => item.querySelector('span').setAttribute('aria-current', 'false'))
                                        dot.setAttribute('aria-current', 'true');
                                        span.setAttribute('aria-current', 'true');
                                    }
                                }
                            });
                        });

                        ariaObserver.observe(dot, {
                            attributes: true,
                            attributeFilter: ['aria-current']
                        });

                        dot.dataset.dotSetup = 'true';
                    }

                    const isSelected = dot.classList.contains('is-selected');
                    if (isSelected) {
                        if (dot.getAttribute('aria-current') === 'step') {
                            dot.removeAttribute('aria-current');
                        }
                        dot.setAttribute('aria-current', 'true');
                    } else {
                        dot.removeAttribute('aria-current');
                    }
                });
            }

            // Function to process and update all slides without overriding focus handling
            let lastSlideCount = 0;
            function processAllSlides() {
                const tabWrapper = carousel.closest('.tab_se_element');
                const tabInactive = (() => {
                    if (!tabWrapper) return false;
                    if (tabWrapper.classList.contains('ct_active')) return false;
                    const ariaHidden = tabWrapper.getAttribute('aria-hidden');
                    if (ariaHidden === 'true') return true;
                    if (ariaHidden === 'false') return false;
                    if (typeof window.getComputedStyle === 'function') {
                        const styles = window.getComputedStyle(tabWrapper);
                        if (styles.display === 'none' || styles.visibility === 'hidden') return true;
                    }
                    return false;
                })();

                const children = carousel.querySelectorAll('.flickity-viewport .flickity-slider > *');
                const totalSlides = applySlideGroupSemantics({
                    slider: carousel,
                    slides: children,
                    skipSlide: isToggleSlide
                });
                if (!totalSlides) {
                    lastSlideCount = 0;
                    return 0;
                }
                //NOT NECCESARY
                // let renderedIndex = 0;
                // children.forEach((slide) => {
                //     if (isToggleSlide(slide)) {
                //         return;
                //     }

                //     renderedIndex += 1;

                //     if (!slide.dataset.slideLabel) {
                //         const label = document.createElement('span');
                //         label.className = 'sr-only';
                //         label.setAttribute('data-slide-label', 'true');
                //         slide.appendChild(label);
                //         slide.dataset.slideLabel = 'true';
                //     }

                //     const existingLabel = slide.querySelector('span.sr-only[data-slide-label="true"]');
                //     const labelText = `Slide ${renderedIndex} of ${totalSlides}`;
                //     if (existingLabel && existingLabel.textContent !== labelText) {
                //         existingLabel.textContent = labelText;
                //     }
                // });

                const syncNavButton = (btn, label) => {
                    if (!btn) return;

                    if (!btn.dataset.ariaLabel) {
                        btn.setAttribute('aria-label', label);
                        btn.dataset.ariaLabel = 'true';
                    }

                    let isVisible = true;
                    if (typeof window.getComputedStyle === 'function') {
                        const styles = window.getComputedStyle(btn);
                        const displayNone = styles.display === 'none';
                        const visibilityHidden = styles.visibility === 'hidden';
                        const opacityZero = parseFloat(styles.opacity || '1') === 0;
                        isVisible = !(displayNone || visibilityHidden || opacityZero);
                    }

                    if (tabInactive || btn.disabled || !isVisible) {
                        btn.setAttribute('tabindex', '-1');
                        btn.setAttribute('aria-hidden', 'true');
                    } else {
                        btn.setAttribute('tabindex', '0');
                        btn.removeAttribute('aria-hidden');
                    }
                };

                syncNavButton(carousel.querySelector('.flickity-prev-next-button.previous'), 'Previous slide');
                syncNavButton(carousel.querySelector('.flickity-prev-next-button.next'), 'Next slide');

                lastSlideCount = totalSlides;
                return totalSlides;
            }

            const autoPlayValue = typeof flickityData.autoPlay === 'number'
                ? flickityData.autoPlay
                : parseInt(flickityData.autoPlay, 10);

            const handleUpdates = () => {
                lastSlideCount = processAllSlides();
                fixFlickityDots();
            };

            handleUpdates();

            let shouldAddToggle = autoPlayValue && autoPlayValue > 0 && lastSlideCount > 1;

            const tabWrapContainer = carousel.closest('.tab_se_wrap');

            if (tabWrapContainer) {
               
                const existingButton = tabWrapContainer.querySelector('.slides-carousel-toggle');
                
                if (existingButton) {
                    return true;
                }
                
                const allElementsWithFlickity = tabWrapContainer.querySelectorAll('[data-flickity]');
                for (const element of allElementsWithFlickity) {
                    try {
                        const flickityConfig = JSON.parse(element.getAttribute('data-flickity') || '{}');
                        const elementAutoPlay = typeof flickityConfig.autoPlay === 'number' 
                            ? flickityConfig.autoPlay 
                            : parseFloat(flickityConfig.autoPlay);
                        if (elementAutoPlay && elementAutoPlay > 0) {
                            shouldAddToggle = true;
                            break;
                        }
                    } catch (e) {
                        console.log('Parse error:', e);
                    }
                }
            }

            carousel.addEventListener('change.flickity', handleUpdates);

            const observer = new MutationObserver(handleUpdates);

            observer.observe(carousel, {
                childList: true,
                subtree: true,
                attributes: false
            });

            const STABILIZATION_DELAY = 2000;
            let stabilizationTimer = setTimeout(() => {
                observer.disconnect();
            }, STABILIZATION_DELAY);

            if (!shouldAddToggle) {
                return true;
            }

            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'slides-carousel-toggle toggle-flicky-btn';
            btn.setAttribute('aria-label', 'Pause carousel autoplay');
            btn.id = 'slides-btn-' + Math.random().toString(36).substr(2, 9);

            let buttonContainer = null;
            let insertionPoint = null;

            if (tabWrapContainer) {
                buttonContainer = tabWrapContainer;
                const tabHeader = tabWrapContainer.querySelector('.tab_se_header');
                const tabContent = tabWrapContainer.querySelector('.tab_se_content');

                if (tabHeader && tabContent) {
                    insertionPoint = tabContent;
                } else {
                    insertionPoint = tabWrapContainer.children[1] || tabWrapContainer.firstChild;
                }
            } else {
                const viewportParent = viewport.parentElement;
                if (viewportParent) {
                    buttonContainer = viewportParent;
                    insertionPoint = viewport;
                } else {
                    buttonContainer = carousel;
                    insertionPoint = carousel.firstChild;
                }
            }

            if (buttonContainer && insertionPoint) {
                buttonContainer.insertBefore(btn, insertionPoint);
            }

            let paused = false;

            const getActiveCarousel = () => {
                if (!tabWrapContainer) {
                    return carousel;
                }

                const activeTab = tabWrapContainer.querySelector('.tab_se_element:not([aria-hidden="true"])');
                if (!activeTab) {
                    return carousel;
                }

                const activeCarousel = activeTab.querySelector('.js_carousel.nt_slider[data-flickity]');
                return activeCarousel || carousel;
            };

            const getAutoPlayFromCarousel = (elem) => {
                if (!elem) return 0;
                try {
                    const config = JSON.parse(elem.getAttribute('data-flickity') || '{}');
                    const value = typeof config.autoPlay === 'number' ? config.autoPlay : parseFloat(config.autoPlay);
                    return isNaN(value) ? 0 : value;
                } catch (e) {
                    return 0;
                }
            };

            const updateToggleVisibility = () => {
                const active = getActiveCarousel();
                const hasAutoplay = getAutoPlayFromCarousel(active) > 0;

                if (hasAutoplay) {
                    btn.style.display = '';
                    btn.removeAttribute('aria-hidden');
                    btn.removeAttribute('tabindex');
                } else {
                    btn.style.display = 'none';
                    btn.setAttribute('aria-hidden', 'true');
                    btn.setAttribute('tabindex', '-1');
                }
            };

            const blocker = (e) => {
                if (!paused) return;
                if (e.target && (e.target.closest('.swatch__list') || e.target.closest('.swatch__list_js'))) {
                    return;
                }
                if (e.isTrusted) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            };

            const addBlockers = () => {
                const target = getActiveCarousel();
                ALL_HOVER.forEach(n => target.addEventListener(n, blocker, true));
            };

            const removeBlockers = () => {
                const target = getActiveCarousel();
                ALL_HOVER.forEach(n => target.removeEventListener(n, blocker, true));
            };

            function emit(root, names) {
                for (const name of names) {
                    const bubbles = name === 'mouseover' || name === 'mouseout';
                    const evt = new MouseEvent(name, { bubbles, cancelable: true });
                    root.dispatchEvent(evt);
                }
            }

            function updateUI() {
                const ICONS = {
                    play: '<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20"><path d="M8 5v14l11-7-11-7z"></path></svg>',
                    pause: '<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20"><path d="M6 5h4v14H6zM14 5h4v14h-4z"></path></svg>'
                };
                btn.innerHTML = paused ? ICONS.play : ICONS.pause;
                btn.setAttribute('aria-label', paused ? 'Resume carousel autoplay' : 'Pause carousel autoplay');

                const target = getActiveCarousel();
                target.classList.toggle('is-paused-by-button', paused);
            }

            function pause() {
                paused = true;
                addBlockers();
                const target = getActiveCarousel();
                emit(target, E_HOVER_IN);
                updateUI();
            }

            function play() {
                paused = false;
                removeBlockers();
                const target = getActiveCarousel();
                emit(target, E_HOVER_OUT);
                updateUI();
            }

            btn.addEventListener('click', () => (paused ? play() : pause()));
            btn.addEventListener('keydown', (e) => {
                if (e.key === ' ') {
                    e.preventDefault();
                }
            });

            if (tabWrapContainer) {
                let previousCarousel = getActiveCarousel();

                const handleTabChange = () => {
                    const currentCarousel = getActiveCarousel();
                    updateToggleVisibility();

                    if (currentCarousel !== previousCarousel) {
                        if (paused) {
                            ALL_HOVER.forEach(n => previousCarousel.removeEventListener(n, blocker, true));
                            ALL_HOVER.forEach(n => currentCarousel.addEventListener(n, blocker, true));
                            emit(currentCarousel, E_HOVER_IN);
                        }

                        previousCarousel.classList.remove('is-paused-by-button');
                        currentCarousel.classList.toggle('is-paused-by-button', paused);

                        previousCarousel = currentCarousel;
                    }
                };

                const tabObserver = new MutationObserver(handleTabChange);
                const tabElements = tabWrapContainer.querySelectorAll('.tab_se_element');

                tabElements.forEach(tabElement => {
                    tabObserver.observe(tabElement, {
                        attributes: true,
                        attributeFilter: ['aria-hidden']
                    });
                });
            }

            updateToggleVisibility();
            updateUI();
            return true;
        }

        function tryProcess() {
            const allSliders = document.querySelectorAll('.js_carousel.nt_slider[data-flickity]');

            if (allSliders.length === 0) return false;

            let processedAny = false;
            allSliders.forEach((carousel) => {
                if (carousel.dataset.autographAccessibilityProcessed) {
                    return;
                }

                try {
                    if (processCarousel(carousel)) {
                        carousel.dataset.autographAccessibilityProcessed = 'true';
                        processedAny = true;
                    }
                } catch (error) {
                    console.error('[Autograph] Error parsing carousel data:', error);
                }
            });

            return processedAny;
        }

        tryProcess();

        const observer = new MutationObserver(() => {
            tryProcess();
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    }

    fixAutographBundleSliders();

    function fixCartRecentlyViewedFocus() {
        setupProductFocusFix({
            shouldRun: () => window.location.pathname.includes('/cart'),
            containerSelector: '#recently_wrap',
            datasetFlag: 'rhFocusFixed',
            onContainerReady: (container) => {
                const removeTabindex = () => {
                    const carousel = container.querySelector('.products');
                    if (carousel && carousel.hasAttribute('tabindex')) {
                        carousel.removeAttribute('tabindex');
                    }
                    return Boolean(carousel);
                };

                if (!removeTabindex()) {
                    const observer = new MutationObserver(() => {
                        if (removeTabindex()) {
                            observer.disconnect();
                        }
                    });

                    observer.observe(container, {
                        childList: true,
                        subtree: true
                    });
                }
            }
        });
    }

    fixCartRecentlyViewedFocus();

    function fixRelatedProductsAccessibility() {
        const container = document.querySelector('.related.product-extra');
        if (!container) return;

        function processProduct(product) {
            if (product.dataset.relatedExtraInfoFixed === 'true') return;

            const titleLink = product.querySelector('.product-info a.cd');
            const jdgmWidget = product.querySelector('.jdgm-widget');

            if (!titleLink || !jdgmWidget) return;

            const titleId = titleLink.id;
            if (!titleId) return;

            const uniqueId = titleId.replace(/^title_related_/, '') || titleId;

            if (typeof window.fixProductExtraInfoAccessibility === 'function') {
                window.fixProductExtraInfoAccessibility(product, titleLink, uniqueId);
            }

            product.dataset.relatedExtraInfoFixed = 'true';
        }

        container.querySelectorAll('.product').forEach(processProduct);

        const observer = new MutationObserver(() => {
            container.querySelectorAll('.product').forEach(processProduct);
        });

        observer.observe(container, { childList: true, subtree: true });
    }

    setTimeout(fixRelatedProductsAccessibility, 500);

    function ensureWishlistFocusStyles() {
        if (document.getElementById('wishlist-focus-style')) return;
        const style = document.createElement('style');
        style.id = 'wishlist-focus-style';
        style.textContent = `
            .wishlist-focus-visible .hover_button {
                opacity: 1 !important;
                pointer-events: auto !important;
                visibility: visible !important;
            }

            .wishlist-focus-visible .pr_atc {
                opacity: 1 !important;
                pointer-events: auto !important;
                visibility: visible !important;
            }
        `;

        document.head.appendChild(style);
    }

    function attachWishlistFocusHandlers(product) {
        if (product.dataset.wishFocusVisibility === 'true') return;
        product.dataset.wishFocusVisibility = 'true';

        const addFocusState = () => product.classList.add('wishlist-focus-visible');
        const removeFocusState = () => {
            requestAnimationFrame(() => {
                if (!product.contains(document.activeElement)) {
                    product.classList.remove('wishlist-focus-visible');
                }
            });
        };

        product.addEventListener('focusin', addFocusState);
        product.addEventListener('focusout', removeFocusState);
    }

    // function fixWishlistFocus() {
    //     const shouldRun = () => window.location.search.includes('view=wish') || window.location.pathname.includes('/wishlist');
    //     if (!shouldRun()) return;

    //     ensureWishlistFocusStyles();

    //     setupProductFocusFix({
    //         shouldRun,
    //         containerSelector: '.prs_wis',
    //         datasetFlag: 'wishFocusFixed',
    //         onProductFixed: (product) => attachWishlistFocusHandlers(product)
    //     });
    // }

    // fixWishlistFocus();

    function fixWishlistRedundantLinks() {
        const wishList = window.location.pathname === '/search' && window.location.search.includes('view=wish');
        if (!wishList) return;

        const productSelector = '.prs_wis .product';

        const runFix = () => {
            const products = document.querySelectorAll(productSelector);
            if (!products.length) return;

            products.forEach((product) => {
                const imageLink = product.querySelector('.product-image a.db');
                const titleLink = product.querySelector('.product-title a, .product-info__inner a');
                const href = titleLink.getAttribute('href');
                    
                if (href) {
                        titleLink.removeAttribute('href')
                        titleLink.tabIndex = "0";
                        titleLink.setAttribute('role', 'link')
                        titleLink.style.cursor = 'pointer'
                        titleLink.addEventListener('click', () => {
                            window.location.href = href;
                        });
                        titleLink.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') {
                                window.location.href = href;
                            }
                        });
                }

                if (imageLink && titleLink && imageLink.dataset.wishlistThumbFixed !== 'true') {
                    window.replaceLinkWithSpan(imageLink, titleLink, true, true);
                    imageLink.dataset.wishlistThumbFixed = 'true';
                }

                const titleHeading = product.querySelector('.product-title');
                if (titleHeading) {
                    const titleLink = titleHeading.querySelector('a[id^="recently-viewed-title-"]');
                    const linkId = titleLink?.id;
                    const uniqueId = linkId?.replace('recently-viewed-title-', '');
                    
                    if (uniqueId) {
                        // const div = document.createElement('div');
                        // div.className = titleHeading.className + ' h3';
                        // div.innerHTML = titleHeading.innerHTML;
                        // div.id = `wishlist-product-title-${uniqueId}`;
                        titleHeading.id = `wishlist-product-title-${uniqueId}`;
                    }
                }

                let titleElement = product.querySelector('.product-title[id^="wishlist-product-title-"]');
                let titleId = titleElement?.id;
                
                if (!titleId) {
                    const existingTitleLink = product.querySelector('.product-title a[id^="recently-viewed-title-"]');
                    if (existingTitleLink && existingTitleLink.id) {
                        titleId = existingTitleLink.id;
                    }
                }

                if (titleId) {
                    const removeBtn = product.querySelector('.hover_button .wis_remve');
                    if (removeBtn) {
                        removeBtn.setAttribute('aria-label', 'Remove From Wish List');
                        removeBtn.setAttribute('aria-describedby', titleId);
                    }
                    
                    const compareBtn = product.querySelector('.hover_button .compare_add');
                    if (compareBtn) {
                        compareBtn.setAttribute('aria-describedby', titleId);
                    }
                    
                    product.querySelectorAll('.js_add_qv').forEach(btn => {
                        btn.setAttribute('aria-describedby', titleId);
                    });
                    
                    product.querySelectorAll('.pr_atc').forEach(btn => {
                        btn.setAttribute('aria-describedby', titleId);
                    });
                }

                // Fix redundant links in .product-info__btns section
                // These links have the same href as the title link, causing WAVE redundant link errors
                const productInfoBtns = product.querySelector('.product-info__btns');
                if (productInfoBtns && productInfoBtns.dataset.redundantLinksFixed !== 'true') {

                    
                    // Convert Quick View link in product-info__btns to span
                    const quickViewLink = productInfoBtns.querySelector('a.js_add_qv');
                    quickViewLink.href = quickViewLink.getAttribute('href') + '/';
                    
                    // Convert Read More / Quick Shop link in product-info__btns to span

                    
                    productInfoBtns.dataset.redundantLinksFixed = 'true';
                }

                if (typeof window.fixProductPriceAccessibility === 'function') {
                    window.fixProductPriceAccessibility(product);
                }
            });
        };

        runFix();

        if (!fixWishlistRedundantLinks.observer) {
            const observer = new MutationObserver(() => runFix());

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            fixWishlistRedundantLinks.observer = observer;
        }
    }

    fixWishlistRedundantLinks();
    
    function fixQuickViewModal() {
        const observer = new MutationObserver(() => {
            const quickView = document.querySelector('.mfp-wrap.mfp-ready #content_quickview');
            if (!quickView) return;

            quickView.setAttribute('role', 'dialog');
            quickView.setAttribute('aria-label', 'Product Quick View');

            const closeBtn = quickView.querySelector('.mfp-close');
            if(closeBtn) {
                closeBtn.setAttribute('aria-label', 'Close');
                closeBtn.removeAttribute('title');
            }

            //commented for now
            // const productTitle = quickView.querySelector('.product_title');
            // productTitle.id = 'product_title_x';
            // quickView.setAttribute('aria-labelledby', productTitle.id);
            // quickView.setAttribute('role', 'dialog');

            quickView.setAttribute('tabindex', '-1');
            quickView.focus();

            const h3 = quickView.querySelector('h3.product-title');
            if(h3) {
                const h1 = document.createElement('h1');
                h1.className = h3.className;
                h1.innerHTML = h3.innerHTML;
                h3.replaceWith(h1);
            }

            quickView.querySelectorAll('.nt_add_w a:not([applied]), .nt_add_cp a:not([applied])').forEach(link => {
                link.setAttribute('applied', 'true');
                const text = link.querySelector('.tt_txt')
                if (!text) return
                const updateLabel = () => link.setAttribute('aria-label', text.textContent);
                updateLabel();
                link.addEventListener('click', () => {
                    setTimeout(() => updateLabel(), 300);
                });
                link.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') setTimeout(() => updateLabel(), 300);
                });
            });

            const images = quickView.querySelectorAll('.js-sl-item .nt_bg_lz');
            images.forEach((img, index) => {
                if (img.getAttribute('applied')) return
                img.setAttribute('applied', 'true');
                img.setAttribute('role', 'img');
                img.setAttribute('aria-label', `Product image ${index + 1} of ${images.length}`);
            });

            //RADIO SEMANTICS
            const group = quickView.querySelector('.swatches-select');
            if (group && !group.getAttribute('applied')) {
                group.setAttribute('applied', 'true')
                const items = Array.from(group.querySelectorAll('.swatch_pr_item'));
                group.setAttribute('role', 'radiogroup');

                items.forEach((item, i) => {
                    item.setAttribute('role', 'radio');

                    const isSelected = item.classList.contains('is-selected');
                    item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
                    item.tabIndex = isSelected ? 0 : -1;
                });

                function selectItem(item) {
                    items.forEach(i => {
                        i.setAttribute('aria-checked', 'false');
                        i.tabIndex = -1;
                    });

                    item.setAttribute('aria-checked', 'true');
                    item.tabIndex = 0;
                    item.querySelector(':scope > *').click();
                    setTimeout(() => {
                        item.focus();
                    }, 100);
                }

                // --- Mouse click ---
                items.forEach(item => {
                    item.addEventListener('click', () => selectItem(item));
                });

                // --- Keyboard support ---
                group.addEventListener('keydown', e => {
                    const currentIndex = items.findIndex(i => i.tabIndex === 0);
                    let newIndex = currentIndex;

                    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                        newIndex = (currentIndex + 1) % items.length;
                        e.preventDefault();
                    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                        newIndex = (currentIndex - 1 + items.length) % items.length;
                        e.preventDefault();
                    } else if (e.key === ' ' || e.key === 'Enter') {
                        selectItem(items[currentIndex]);
                        e.preventDefault();
                        return;
                    }

                    if (newIndex !== currentIndex) {
                        selectItem(items[newIndex]);
                    }
                });
            }
            //END OF RADIO SEMANTICS

            if (typeof window.fixProductPriceAccessibility === 'function') {
                window.fixProductPriceAccessibility(quickView);
            }

            const reviewStars = quickView.querySelector('.jdgm-prev-badge__stars');
            if (reviewStars) {
                const starsValue = reviewStars.getAttribute('data-score');
                reviewStars.setAttribute('aria-label', `${starsValue} out of 5 stars`);
            }

            const flickityButtons = quickView.querySelectorAll('.nt_carousel_qv .flickity-button');
            if (flickityButtons.length > 0) {
                flickityButtons.forEach(btn => {
                    btn.setAttribute('tabindex', '-1');
                    btn.setAttribute('aria-hidden', 'true');
                });
            }

            const flickityViewport = quickView.querySelector('.nt_carousel_qv .flickity-viewport');
            if (flickityViewport) {
                flickityViewport.setAttribute('aria-hidden', 'true');
            }

            trapFocusReuse2nd(quickView)
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixQuickViewModal();

    function fixHideAmountContainer() {
        const hideContent = () => {
            const paymentTerms = document.querySelectorAll('shopify-payment-terms');
            paymentTerms.forEach(element => {
                if (!element.shadowRoot) return;
                const content = element.shadowRoot.querySelector('#prequalAmountContainer');
                if (!content || content.dataset.prequalHidden === 'true') return;

                content.setAttribute('tabindex', '-1');
                content.setAttribute('aria-hidden', 'true');

                content.querySelectorAll('div, iframe, span, button').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                    item.setAttribute('aria-hidden', 'true');
                });

                content.dataset.prequalHidden = 'true';
            });
        };

        hideContent();

        if (!fixHideAmountContainer.observer) {
            const observer = new MutationObserver(() => hideContent());

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            fixHideAmountContainer.observer = observer;
        }
    }

    fixHideAmountContainer();

    function fixCartViewModal() {
        const applyFix = () => {
            const popup = document.querySelector('.white-popup.add-to-cart-popup.popup-added_to_cart');
            if (!popup) return;

            popup.setAttribute('role', 'dialog');
            popup.setAttribute('aria-label', 'Added to Cart');

            if (!popup.dataset.cartTrapObserver) {
                const trapTarget = popup.closest('.mfp-wrap') || popup;

                if (trapTarget.__trapFocusHandler) {
                    trapTarget.removeEventListener('keydown', trapTarget.__trapFocusHandler);
                    delete trapTarget.__trapFocusHandler;
                    delete trapTarget.dataset.trapFocusBound;
                }

                const handleKeydown = (event) => {
                    if (event.key !== 'Tab') return;

                    const focusables = Array.from(
                        (popup.closest('.mfp-wrap') || popup).querySelectorAll(
                            'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
                        )
                    ).filter((element) => {
                        if (element.disabled) return false;
                        if (element.closest('[aria-hidden="true"]')) return false;
                        return element.tabIndex >= 0;
                    });

                    if (!focusables.length) return;

                    const first = focusables[0];
                    const last = focusables[focusables.length - 1];

                    if (event.shiftKey) {
                        if (document.activeElement === first || !popup.contains(document.activeElement)) {
                            event.preventDefault();
                            last.focus();
                        }
                    } else {
                        if (document.activeElement === last) {
                            event.preventDefault();
                            first.focus();
                        }
                    }
                };

                trapTarget.addEventListener('keydown', handleKeydown);
                trapTarget.dataset.trapFocusBound = 'true';
                trapTarget.__trapFocusHandler = handleKeydown;
                popup.dataset.cartTrapObserver = 'true';
            }
            const initialFocusable = popup.querySelector('.close-popup');
            if (initialFocusable) {
                 initialFocusable.focus();
            }
            popup.dataset.cartModalFixed = 'true';
        };

        applyFix();

        if (!fixCartViewModal.observer) {
            const observer = new MutationObserver(() => applyFix());

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            fixCartViewModal.observer = observer;
        }
    }

    fixCartViewModal();

    function fixKitchenPackagesFocus() {
        // const shouldRun = () =>
        //     window.location.pathname.includes('/kitchen-packages') ||
        //     window.location.pathname.includes('/zline-kitchen-and-bath') ||
        //     window.location.pathname.includes('/virtual-kitchen');

        // if (!shouldRun()) return;

        // const container = document.querySelectorAll('.products.nt_products_holder');

        // if (!container.length) return;

        setupProductFocusFix({
            shouldRun: () => document.querySelectorAll('.products.nt_products_holder').length > 0,
            containerSelector: () => Array.from(document.querySelectorAll('.products.nt_products_holder')),
            datasetFlag: 'kitchenPackagesFocusFixed',
            onContainerReady: (carousel) => {
                const removeTabindex = () => {
                    if (carousel.hasAttribute('tabindex')) {
                        carousel.removeAttribute('tabindex');
                    }
                };

                removeTabindex();

                if (!carousel.dataset.kpTabObserver) {
                    const observer = new MutationObserver(mutations => {
                        mutations.forEach(mutation => {
                            if (mutation.attributeName === 'tabindex') {
                                removeTabindex();
                            }
                        });
                    });

                    observer.observe(carousel, {
                        attributes: true,
                        attributeFilter: ['tabindex']
                    });

                    carousel.dataset.kpTabObserver = 'true';
                }
            },
            onProductFixed: null
        });
        const panels = document.querySelectorAll('.tab_se_element');
        document.querySelectorAll('.tab_se_header li a').forEach((link, index) => {
                link.addEventListener('click', () => {
                                    const panel = panels[index]
                setupProductFocusFix({
                shouldRun: () => panel.querySelectorAll('.products.nt_products_holder').length > 0,
                containerSelector: () => Array.from(panel.querySelectorAll('.products.nt_products_holder')),
                datasetFlag: 'kitchenPackagesFocusFixed',
                onContainerReady: (carousel) => {
                    const removeTabindex = () => {
                        if (carousel.hasAttribute('tabindex')) {
                            carousel.removeAttribute('tabindex');
                        }
                    };

                    removeTabindex();

                    if (!carousel.dataset.kpTabObserver) {
                        const observer = new MutationObserver(mutations => {
                            mutations.forEach(mutation => {
                                if (mutation.attributeName === 'tabindex') {
                                    removeTabindex();
                                }
                            });
                        });

                        observer.observe(carousel, {
                            attributes: true,
                            attributeFilter: ['tabindex']
                        });

                        carousel.dataset.kpTabObserver = 'true';
                    }
                },
                onProductFixed: null
            });
                });

        });
    }

    fixKitchenPackagesFocus();

    // function fixLgApplianceSliderFocus() {
    //     const shouldRun = () => window.location.pathname.includes('lg-appliances');
    //     if (!shouldRun()) return;

    //     setupProductFocusFix({
    //         shouldRun: () => document.querySelectorAll('.products.nt_products_holder .product').length > 0,
    //         containerSelector: () => Array.from(document.querySelectorAll('.products.nt_products_holder')),
    //         datasetFlag: 'lgApplianceFocusFixed'
    //     });
    // }

    // fixLgApplianceSliderFocus();

    function fixTabCategoryLists() {
        let generatedTabId = 0;
        const tablistKeyHandlersBound = new WeakSet();
        const tablistClassObservers = new WeakMap();
        const tabWrapObservers = new WeakMap();
        const tabSyncQueue = new WeakMap();
        const SLIDE_LABEL_REGEX = /^slide\s+\d+\s+of\s+\d+/i;

        const stripSliderSemantics = (wrap) => {
            if (!wrap) return;
            const elements = wrap.querySelectorAll('[role=\"group\"][aria-label], [aria-label^=\"Slide \"]');

            elements.forEach((el) => {
                const label = el.getAttribute('aria-label') || '';
                if (!SLIDE_LABEL_REGEX.test(label)) return;
                if (el.closest('[data-flickity]')) return;

                if (el.getAttribute('role') === 'group') {
                    el.removeAttribute('role');
                }
                el.removeAttribute('aria-label');
            });

            if (!wrap.closest('[data-flickity]')) {
                wrap.removeAttribute('data-slide-semantics-total');
            }
        };

        const getNavigableTabs = (tablist) => Array.from(tablist.querySelectorAll('a[role=\"tab\"]'));

        const getPanelFocusables = (panel) => {
            if (!panel) return [];
            if (typeof window.getFocusableElements === 'function') {
                return window.getFocusableElements(panel);
            }

            const selector = 'a[href], button, input, select, textarea, [tabindex], [role="button"]';
            return Array.from(panel.querySelectorAll(selector)).filter((el) => {
                if (el.disabled) return false;
                if (el.closest('.mfp-hide')) return false;
                return true;
            });
        };

        const setPanelFocusableState = (panel, enabled) => {
            if (!panel) return;
            const focusables = getPanelFocusables(panel);
            focusables.forEach((el) => {
                if (!el.dataset.tabPanelOriginalTabindex) {
                    el.dataset.tabPanelOriginalTabindex = el.hasAttribute('tabindex')
                        ? el.getAttribute('tabindex')
                        : 'none';
                }

                if (enabled) {
                    const original = el.dataset.tabPanelOriginalTabindex;
                    if (original && original !== 'none') {
                        el.setAttribute('tabindex', original);
                    } else {
                        el.removeAttribute('tabindex');
                    }
                    if (el.getAttribute('aria-hidden') === 'true') {
                        el.removeAttribute('aria-hidden');
                    }
                } else {
                    el.setAttribute('tabindex', '-1');
                    el.setAttribute('aria-hidden', 'true');
                }
            });
        };

        const syncPanelsForWrap = (wrap, forcedActivePanel) => {
            if (!wrap) return;
            if (wrap.dataset.tabSyncing === 'true') return;

            const panels = Array.from(wrap.querySelectorAll('.tab_se_content .tab_se_element'));
            if (!panels.length) return;

            wrap.dataset.tabSyncing = 'true';

            let activePanel = forcedActivePanel && panels.includes(forcedActivePanel)
                ? forcedActivePanel
                : panels.find((panel) => panel.classList.contains('ct_active')) ||
                    panels.find((panel) => panel.getAttribute('aria-hidden') === 'false') ||
                    panels[0];

            panels.forEach((panel) => {
                const selected = panel === activePanel;
                panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
                setPanelFocusableState(panel, selected);
            });

            wrap.dataset.tabSyncing = 'false';
        };

        const scheduleSyncPanels = (wrap) => {
            if (!wrap) return;
            if (tabSyncQueue.has(wrap)) return;
            const handle = requestAnimationFrame(() => {
                tabSyncQueue.delete(wrap);
                syncPanelsForWrap(wrap);
            });
            tabSyncQueue.set(wrap, handle);
        };

        const processTablists = () => {
            const tablists = document.querySelectorAll('.tab_se_wrap .tab_cat_title');

            tablists.forEach((tablist) => {
                const wrap = tablist.closest('.tab_se_wrap');
                if (!wrap || !wrap.querySelector('.tab_se_content .tab_se_element')) {
                    return;
                }

                stripSliderSemantics(wrap);

                const tabs = Array.from(tablist.querySelectorAll('a'));
                if (!tabs.length) {
                    return;
                }

                tablist.setAttribute('role', 'tablist');
                tablist.querySelectorAll('li.dib').forEach(dib => dib.setAttribute('role', 'none'))

                const prepareTab = (tab, index) => {
                    tab.setAttribute('role', 'tab');
                    if (!tab.id) {
                        generatedTabId += 1;
                        tab.id = `tab-cat-${generatedTabId}-${index}`;
                    }

                    if (!tab.getAttribute('aria-controls')) {
                        const targetId = tab.dataset.bid || (tab.hash ? tab.hash.slice(1) : '');
                        if (targetId && document.getElementById(targetId)) {
                            tab.setAttribute('aria-controls', targetId);
                        }
                    }

                    const panelId = tab.getAttribute('aria-controls');
                    if (panelId) {
                        const panel = document.getElementById(panelId);
                        if (panel) {
                            panel.setAttribute('role', 'tabpanel');
                            panel.setAttribute('aria-labelledby', tab.id);
                        }
                    }
                };

                const isTabVisuallyActive = (tab) => {
                    const parent = tab.parentElement;
                    return tab.classList.contains('tt_active') ||
                        tab.classList.contains('active') ||
                        (parent && (parent.classList.contains('tt_active') || parent.classList.contains('active')));
                };

                const syncTabState = (forcedTab) => {
                    const currentTabs = Array.from(tablist.querySelectorAll('a'));
                    currentTabs.forEach((tab, index) => prepareTab(tab, index));

                    const tabsList = currentTabs.filter((tab) => tab.getAttribute('role') === 'tab');
                    if (!tabsList.length) {
                        return;
                    }

                    let activeTab = forcedTab && tabsList.includes(forcedTab)
                        ? forcedTab
                        : tabsList.find(isTabVisuallyActive);

                    if (!activeTab) {
                        activeTab = tabsList[0];
                    }

                    tabsList.forEach((tab) => {
                        const selected = tab === activeTab;
                        tab.setAttribute('aria-selected', String(selected));
                        tab.tabIndex = selected ? 0 : -1;

                        const panelId = tab.getAttribute('aria-controls');
                        if (panelId) {
                            const panel = document.getElementById(panelId);
                            if (panel) {
                                panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
                                setPanelFocusableState(panel, selected);
                                const wrap = tab.closest('.tab_se_wrap');
                                if (wrap) {
                                    syncPanelsForWrap(wrap, panel);
                                }
                            }
                        }
                    });
                };

                syncTabState();

                if (!tablistKeyHandlersBound.has(tablist)) {
                    const handleClick = (event) => {
                        const tab = event.target.closest('a[role="tab"]');
                        if (!tab || !tablist.contains(tab)) {
                            return;
                        }
                        event.preventDefault();
                        requestAnimationFrame(() => syncTabState(tab));
                    };

                    const handleKeydown = (event) => {
                        const tabsList = getNavigableTabs(tablist);
                        if (!tabsList.length) {
                            return;
                        }

                        const stopAll = () => {
                            event.preventDefault();
                            event.stopPropagation();
                            if (typeof event.stopImmediatePropagation === 'function') {
                                event.stopImmediatePropagation();
                            }
                        };

                        const activeElement = document.activeElement;
                        const currentIndex = tabsList.indexOf(activeElement);

                        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                            if (currentIndex === -1) return;
                            stopAll();
                            const direction = event.key === 'ArrowRight' ? 1 : -1;
                            const nextIndex = (currentIndex + direction + tabsList.length) % tabsList.length;
                            tabsList[nextIndex].focus();
                            return;
                        }

                        if (event.key === 'Home' && currentIndex !== -1) {
                            stopAll();
                            tabsList[0].focus();
                            return;
                        }

                        if (event.key === 'End' && currentIndex !== -1) {
                            stopAll();
                            tabsList[tabsList.length - 1].focus();
                            return;
                        }

                        if ((event.key === 'Enter' || event.key === ' ') && currentIndex !== -1) {
                            stopAll();
                            tabsList[currentIndex].click();
                        }
                    };

                    tablist.addEventListener('click', handleClick, true);
                    tablist.addEventListener('keydown', handleKeydown, true);
                    tablistKeyHandlersBound.add(tablist);
                }

                if (!tablistClassObservers.has(tablist)) {
                    const observer = new MutationObserver(() => syncTabState());
                    observer.observe(tablist, {
                        attributes: true,
                        attributeFilter: ['class'],
                        subtree: true,
                        childList: true
                    });
                    tablistClassObservers.set(tablist, observer);
                }

                const wrapObserver = tabWrapObservers.get(wrap);
                if (!wrapObserver) {
                    const observer = new MutationObserver((mutations) => {
                        for (const mutation of mutations) {
                            if (mutation.type === 'attributes') {
                                stripSliderSemantics(wrap);
                                scheduleSyncPanels(wrap);
                                return;
                            }
                            if (mutation.type === 'childList') {
                                stripSliderSemantics(wrap);
                                scheduleSyncPanels(wrap);
                                return;
                            }
                        }
                    });

                    observer.observe(wrap, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['class', 'aria-hidden']
                    });

                    tabWrapObservers.set(wrap, observer);
                }

                syncPanelsForWrap(wrap);
            });
        };

        processTablists();

        if (!fixTabCategoryLists.observer) {
            fixTabCategoryLists.observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    for (const node of mutation.addedNodes) {
                        if (!(node instanceof Element)) continue;
                        if (
                            node.matches('.tab_se_wrap .tab_cat_title') ||
                            node.querySelector('.tab_se_wrap .tab_cat_title')
                        ) {
                            processTablists();
                            return;
                        }
                    }
                }
            });

            fixTabCategoryLists.observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }

    fixTabCategoryLists();

    //DONE IN HTML FILES
    // function fixLGBannerAccessibility() {
    //     // if (!window.location.pathname.includes('lg-appliances')) return;
        
    //     const tiles = document.querySelectorAll('.banner_hzoom.nt_promotion, .nt_banner_holder .nt_promotion, .nt_cats_holder .cat_grid_item');
    //     if (!tiles.length) return;

    //     const formatLabelFromHref = (href) => {
    //         if (!href) return '';
    //         const sanitized = decodeURIComponent(href.split('?')[0] || '')
    //             .split('/')
    //             .filter(Boolean)
    //             .pop() || '';
    //         if (!sanitized) return '';
    //         return sanitized
    //             .replace(/[\-_]+/g, ' ')
    //             .replace(/\s+/g, ' ')
    //             .trim()
    //             .replace(/\b\w/g, (char) => char.toUpperCase());
    //     };

    //     const getLabelData = (tile, linkHref) => {
    //         const titleElement = tile.querySelector('.cat_grid_item__title');
    //         if (titleElement && titleElement.textContent.trim()) {
    //             return {
    //                 element: titleElement,
    //                 text: titleElement.textContent.trim()
    //             };
    //         }

    //         const promotionCopy = tile.querySelector('.nt_promotion_html');
    //         if (promotionCopy) {
    //             const promotionText = promotionCopy.textContent.trim();
    //             if (promotionText) {
    //                 return {
    //                     element: promotionCopy,
    //                     text: promotionText
    //                 };
    //             }
    //         }

    //         const heading = tile.querySelector('h3, h4, .nt_promotion .title, .nt_promotion .banner-title');
    //         if (heading && heading.textContent.trim()) {
    //             return {
    //                 element: heading,
    //                 text: heading.textContent.trim()
    //             };
    //         }

    //         return {
    //             element: null,
    //             text: formatLabelFromHref(linkHref) || 'View category'
    //         };
    //     };

    //     tiles.forEach((tile) => {
    //         const link = tile.querySelector('.cat_grid_item__link[href], a.pa[href], a[href]');
    //         if (!link) return;
    //         if (link.dataset.lgBannerFixed) return;

    //         const linkHref = link.getAttribute('href') || '';
    //         const { element: labelElement, text: labelText } = getLabelData(tile, linkHref);

    //         if (labelElement) {
    //             if (!labelElement.id) {
    //                 labelElement.id = `lg-banner-title-${Math.random().toString(16).slice(2)}`;
    //             }
    //             link.setAttribute('aria-labelledby', labelElement.id);
    //             link.removeAttribute('aria-label');
    //         } else {
    //             link.setAttribute('aria-label', labelText);
    //             link.removeAttribute('aria-labelledby');
    //         }

    //         tile.removeAttribute('aria-label');
    //         tile.removeAttribute('aria-labelledby');
    //         tile.removeAttribute('role');
    //         tile.removeAttribute('tabindex');

    //         tile.style.cursor = 'pointer';

    //         link.removeAttribute('aria-hidden');
    //         link.removeAttribute('role');
    //         link.removeAttribute('tabindex');

    //         const activateLink = () => link.click();

    //         tile.addEventListener('click', (event) => {
    //             if (event.target.closest('a')) return;
    //             activateLink();
    //         });

    //         link.dataset.lgBannerFixed = 'true';
    //     });
    // }

    // fixLGBannerAccessibility();

    function fixBannerHeadingsStructure() {
        const container = document.querySelector('.type_banner');
        if (!container) return;

        const observer = new MutationObserver(() => {
            const shadowWraps = container.querySelectorAll('.nt_promotion .shadow_wrap');
            if (!shadowWraps.length) return;

            shadowWraps.forEach(wrap => {
                const h3 = wrap.querySelector('h3');
                if (h3) {
                    const div = document.createElement('div');
                    div.className = h3.className + ' h3';
                    div.innerHTML = h3.innerHTML;
                    div.id = h3.id;
                    div.style = "color: #fff;"
                    h3.replaceWith(div);
                }

                const h4 = wrap.querySelector('h4');
                if (h4) h4.remove();
            });

            observer.disconnect();
        });

        observer.observe(container, { childList: true, subtree: true });
    }

    fixBannerHeadingsStructure();

    function fixContactsTable() {
      if (!window.location.pathname.includes('/contact-us')) return;

      const headingSelector = '.section-title h2.h3';
      const tableSelector = '.code_setting table';
      const heading = document.querySelector(headingSelector);
      const table = document.querySelector(tableSelector);
      if (!heading || !table || table.dataset.tableContactsFixed === 'true') return;

      if (!heading.id) {
          let headingId = 'tableContacts';
          if (document.getElementById(headingId) && document.getElementById(headingId) !== heading) {
              headingId = `${headingId}${Math.random().toString(16).slice(2)}`;
          }
          heading.id = headingId;
      }

      table.setAttribute('aria-labelledby', heading.id);
      table.dataset.tableContactsFixed = 'true';
  }

  fixContactsTable();

    function fixAriaLabelButton() {
        if (!window.location.pathname.includes('/kitchen-packages')) return;

        const buttonSelector = 'a.button.btn--secondary.btn--small.btn--style-1';

        const apply = () => {
            document.querySelectorAll(buttonSelector).forEach(button => {
                if (button.hasAttribute('aria-label')) {
                    button.removeAttribute('aria-label');
                }
            });
        };

        apply();

        const observer = new MutationObserver(() => apply());

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-label', 'class']
        });
    }

    function handleSwatchChange(swatchElement) {
        const imagebg = swatchElement.dataset.bgset;
        const id = swatchElement.dataset.id;
        const vid = swatchElement.dataset.vid;

        const product = swatchElement.closest('.nt_pr');
        if (!product) return;

        const image = product.querySelector('.main-img');
        if (!image) return;

        const container = swatchElement.closest('.swatch__list_js, .swatch__list');
        const currentSwatch = container?.querySelector('.current-swatch');
        if (currentSwatch) currentSwatch.classList.remove('current-swatch');

        if (container) {
            const allSwatches = container.querySelectorAll('.swatch__list--item:not(.swatch__list--more)');
            allSwatches.forEach(swatch => {
                swatch.setAttribute('aria-pressed', swatch === swatchElement ? 'true' : 'false');
            });
        }

        swatchElement.classList.add('current-swatch');

        product.classList.add('nt-swatched');

        if (swatchElement.classList.contains('loaded_swatch')) {
            image.classList.add('hide_ic_lz');
        } else {
            image.classList.remove('hide_ic_lz');
        }
        swatchElement.classList.add('loaded_swatch');

        image.dataset.bgset = imagebg;
        image.dataset.id = id;

        if (vid) {
            const productTitle = product.querySelector('.product-title > a');
            
            if (productTitle) {
                let href = productTitle.getAttribute('new_href');
                if (href.includes('?variant=')) {
                    href = href.split('?variant=')[0] + '?variant=' + vid;
                } else if (href.includes('?')) {
                    href = href.split('&variant=')[0] + '&variant=' + vid;
                } else {
                    href = href + '?variant=' + vid;
                }

                productTitle.setAttribute('new_href', href)
                // product.querySelectorAll('a').forEach(link => {
                //     console.log(link, 'link')
                //     link.href = href
                // });
            }

            const quickView = product.querySelector('.nt_add_qv');
            if (quickView) quickView.dataset.id = vid;
        }
    }

    function fixFornoSwatchesKeyboard() {
        //   const shouldRun = () =>
        //     window.location.pathname.includes('/forno') ||
        //     window.location.pathname.includes('/zline-kitchen-and-bath');

        // if (!shouldRun()) return;

        

        const apply = () => {
            
            const swatchContainers = document.querySelectorAll('.swatch__list');
            if (!swatchContainers.length) return;
            
            swatchContainers.forEach(container => {
                if (!container.classList.contains('lazyloaded')) return;
                if (container.dataset.keyboardFixed === 'true') return;

                const product = container.closest('.pr_grid_item.product, .product-inner, .product');
                const titleLink = product?.querySelector('.product-title a');
                let describedById = null;
                if (titleLink) {
                    if (!titleLink.id) {
                        titleLink.id = 'swatch-title-' + Math.random().toString(36).slice(2, 9);
                    }
                    describedById = titleLink.id;
                }

                const swatchesMores = container.querySelectorAll('.swatch__list--more a');
                swatchesMores.forEach(item => {
                    item.setAttribute('aria-label', 'Show more colors');
                    item.setAttribute('aria-describedby', describedById);
                });

                const swatches = container.querySelectorAll('.swatch__list--item:not(.swatch__list--more)');

                swatches.forEach((swatch, index) => {
                    swatch.setAttribute('tabindex', '0');
                    swatch.setAttribute('role', 'button');
                    swatch.setAttribute('aria-pressed', 'false');
                    if (describedById) {
                        swatch.setAttribute('aria-describedby', describedById);
                    }

                    const tooltipText = swatch.querySelector('.tt_txt');
                    if (tooltipText && tooltipText.textContent.trim()) {
                        swatch.setAttribute('aria-label', `Showcase: ${tooltipText.textContent.trim()}`);
                    }

                    const swatchesArray = Array.from(swatches);

                    swatch.addEventListener('focus', () => {
                        // handleSwatchChange(swatch);
                    });

                    swatch.addEventListener('click', (e) => {
                        handleSwatchChange(swatch);
                    });

                    swatch.addEventListener('blur', () => {
                        swatch.classList.remove('current-swatch');
                    });

                    swatch.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleSwatchChange(swatch);
                        }

                        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                            e.preventDefault();
                            const nextIndex = (index + 1) % swatchesArray.length;
                            swatchesArray[nextIndex].focus();
                        }

                        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                            e.preventDefault();
                            const prevIndex = (index - 1 + swatchesArray.length) % swatchesArray.length;
                            swatchesArray[prevIndex].focus();
                        }
                    });

                    swatch.addEventListener('mouseenter', () => {
                        handleSwatchChange(swatch, false);
                    });
                });

                container.dataset.keyboardFixed = 'true';
            });
        };

        apply();

        const observer = new MutationObserver(() => apply());
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function fixProductCheckbox() {
        const apply = () => {
            const checkboxes = document.querySelectorAll('.sg-pro-access-checkbox');

            checkboxes.forEach(checkbox => {
                if (checkbox.dataset.keyboardFixed === 'true') return;

                checkbox.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();

                        checkbox.checked = !checkbox.checked;

                        const changeEvent = new Event('change', { bubbles: true });
                        checkbox.dispatchEvent(changeEvent);
                    }
                });

                checkbox.dataset.keyboardFixed = 'true';
            });
        };

        apply();

        const container = document.getElementById('spiceaddonsappid');
        if (container) {
            const observer = new MutationObserver(() => apply());
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function fixProductFocusOrder() {
        const apply = () => {
            const quantityContainers = document.querySelectorAll('.quantity');

            quantityContainers.forEach(container => {
                if (container.dataset.focusOrderFixed === 'true') return;

                const input = container.querySelector('input[type="number"][name="quantity"]');
                const minusButton = container.querySelector('button.minus');
                const plusButton = container.querySelector('button.plus');

                if (!input || !minusButton || !plusButton) return;

                container.insertBefore(minusButton, input);

                const nextElement = input.nextSibling;
                if (nextElement) {
                    container.insertBefore(plusButton, nextElement);
                } else {
                    container.appendChild(plusButton);
                }

                container.dataset.focusOrderFixed = 'true';
            });
        };

        apply();

        const container = document.getElementById('sp_qty_ppr');
        if (container) {
            const observer = new MutationObserver(() => apply());
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function fixAddToCartFocusOrder() {
        const apply = () => {
            const forms = document.querySelectorAll('form.variations_form');

            forms.forEach(form => {
                if (form.dataset.cartOrderFixed === 'true') return;

                const quantityDiv = form.querySelector('.quantity');
                const addToCartButton = form.querySelector('.single_add_to_cart_button');

                if (!quantityDiv || !addToCartButton) return;

                quantityDiv.parentNode.insertBefore(addToCartButton, quantityDiv.nextSibling);

                form.dataset.cartOrderFixed = 'true';
            });
        };

        apply();

        const container = document.getElementById('spiceaddonsappid');
        if (container) {
            const observer = new MutationObserver(() => apply());
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function fixProductThumbnails() {
        const apply = () => {
            const thumbnails = document.querySelectorAll('.js-sl-item');

            thumbnails.forEach(thumbnail => {
                if (thumbnail.dataset.thumbnailKeyboardFixed === 'true') return;

                thumbnail.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();

                        const mdid = thumbnail.dataset.mdid;
                        if (!mdid) return;

                        const carousel = document.querySelector('.p-thumb.flickity-enabled');
                        if (!carousel) return;

                        const flkty = Flickity.data(carousel);
                        if (!flkty) return;

                        const targetSlide = carousel.querySelector(`.flickity-slider [data-mdid="${mdid}"]`);
                        if (!targetSlide) return;

                        const cells = carousel.querySelectorAll('.flickity-slider .js-sl-item');
                        const targetIndex = Array.from(cells).indexOf(targetSlide);

                        if (targetIndex >= 0) {
                            flkty.select(targetIndex);
                        }
                    }
                });

                thumbnail.dataset.thumbnailKeyboardFixed = 'true';
            });
        };

        apply();

        const container = document.querySelector('.product-images.img_action_popup.pr_sticky_img');
        if (container) {
            const observer = new MutationObserver(() => apply());
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function fixStickyFooter() {
        const apply = () => {
            const stickyFooter = document.querySelector('.sticky_atc_wrap');
            if (!stickyFooter) return;

            stickyFooter.setAttribute('aria-hidden', 'true');

            const focusableElements = stickyFooter.querySelectorAll('input, button, a, select, textarea, [tabindex]');
            focusableElements.forEach(element => {
                element.setAttribute('tabindex', '-1');
            });

        };

        apply();
        
        const container = document.getElementById('shopify-section-sticky_atc');
        if (container) {
            const observer = new MutationObserver(() => apply());
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function fixCartQuantityFocusOrder() {
        const apply = () => {
            const cartQuantityContainers = document.querySelectorAll('.mini_cart_actions .quantity');
            if (!cartQuantityContainers.length) return;

            cartQuantityContainers.forEach(container => {
                if (container.dataset.cartFocusOrderFixed === 'true') return;

                const label = container.querySelector('label');
                const input = container.querySelector('input.qty_cart_js');
                const minusButton = container.querySelector('button.minus');
                const plusButton = container.querySelector('button.plus');

                if (!input || !minusButton || !plusButton) return;

                container.insertBefore(minusButton, container.firstChild);

                if (label) {
                    container.insertBefore(label, minusButton.nextSibling);
                }

                const afterElement = label || minusButton;
                container.insertBefore(input, afterElement.nextSibling);

                container.insertBefore(plusButton, input.nextSibling);

                container.dataset.cartFocusOrderFixed = 'true';

            });
        };

        apply();

        const container = document.querySelector('.frm_cart_page .cart_items');
        if (container) {
            const observer = new MutationObserver(() => apply());
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function fixFeatureColumnRedundantLinks() {
        const apply = () => {
            const featureSections = document.querySelectorAll('.type_feature_columns .nt_banner_holder');

            featureSections.forEach(section => {
                const items = section.querySelectorAll('.cat_space_item');

                items.forEach((item, itemIndex) => {
                    if (item.dataset.redundantLinkFixed === 'true') return;

                    const categoryContent = item.querySelector('.category-content');
                    if (!categoryContent) return;

                    const h6Elements = categoryContent.querySelectorAll('.rte-setting h6');
                    h6Elements.forEach(h6 => {
                        const div = document.createElement('div');
                        if (typeof window.copyAttributes === 'function') {
                            window.copyAttributes(h6, div);
                        }
                        div.className = (h6.className || '') + (h6.className ? ' ' : '') + 'h6';
                        div.innerHTML = h6.innerHTML;
                        h6.replaceWith(div);
                    });

                    const links = categoryContent.querySelectorAll('a[href]');
                    if (links.length < 2) return;

                    const titleLink = links[0];
                    const readButton = links[links.length -1];

                    if (!titleLink || !readButton) return;
                    if (!titleLink.id) {
                        titleLink.id = `feature-title-${itemIndex}-${Math.random().toString(36).substr(2, 5)}`;
                    }

                    if(!readButton.classList.contains('skip_aria_described_attr')) {
                        readButton.setAttribute('aria-describedby', titleLink.id);
                    }

                    if (typeof window.replaceLinkWithSpan === 'function') {
                        window.replaceLinkWithSpan(titleLink, readButton, false, false);
                    }

                    item.dataset.redundantLinkFixed = 'true';
                });
            });
        };

        apply();

        const observer = new MutationObserver(() => apply());
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function fixSortingDropdownAccessibility() {
        const apply = () => {
            const sortingContainers = document.querySelectorAll('.boost-sd__sorting');

            sortingContainers.forEach(container => {
                if (container.dataset.sortingAccessibilityFixed === 'true') return;
                const parent = container.closest('.boost-sd__toolbar-item');
                parent.removeAttribute('aria-label');
                parent.removeAttribute('role')
                const toggleButton = container.querySelector('.boost-sd__sorting-button');
                const optionsList = container.querySelector('.boost-sd__sorting-list');
                const optionButtons = container.querySelectorAll('.boost-sd__sorting-option-item');

                if (!toggleButton || !optionsList) return;

                const listId = `${container.id || Math.random().toString(36).slice(2)}-sorting-list`;
                optionsList.id = listId;

                toggleButton.setAttribute('role', 'combobox');
                toggleButton.setAttribute('aria-haspopup', 'listbox');
                toggleButton.setAttribute('aria-controls', listId);
                toggleButton.setAttribute('aria-expanded', 'false');

                optionsList.setAttribute('role', 'listbox');

                optionButtons.forEach(optionBtn => {
                    optionBtn.setAttribute('role', 'option');
                    const isSelected = optionBtn.classList.contains('active');
                    optionBtn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                    optionBtn.setAttribute('tabindex', '0');
                });

                const isMenuOpen = () =>
                    optionsList.classList.contains('boost-sd__sorting-list--active');

                const openMenu = () => {
                    optionsList.classList.add('boost-sd__sorting-list--active');
                    toggleButton.setAttribute('aria-expanded', 'true');
                };

                const closeMenu = () => {
                    optionsList.classList.remove('boost-sd__sorting-list--active');
                    toggleButton.setAttribute('aria-expanded', 'false');
                };

                const toggleMenu = () => {
                    if (isMenuOpen()) {
                        closeMenu();
                    } else {
                        openMenu();
                        const firstOption = optionButtons[0];
                        if (firstOption) setTimeout(() => firstOption.focus(), 10);
                    }
                };

                toggleButton.addEventListener('click', () => {
                    toggleMenu();
                });
                toggleButton.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleMenu();
                    } else if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        openMenu();
                        if (optionButtons[0]) setTimeout(() => optionButtons[0].focus(), 10);
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        openMenu();
                        const last = optionButtons[optionButtons.length - 1];
                        if (last) setTimeout(() => last.focus(), 10);
                    } else if (e.key === 'Escape' && isMenuOpen()) {
                        e.preventDefault();
                        closeMenu();
                    }
                });

                optionButtons.forEach((optionBtn, index) => {
                    optionBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        const enterEvent = new KeyboardEvent('keydown', {
                            key: 'Enter',
                            bubbles: true
                        });

                        optionBtn.dispatchEvent(enterEvent);
                    })
                    optionBtn.addEventListener('keydown', (e) => {
                        const lastIdx = optionButtons.length - 1;

                        if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            const next = optionButtons[index + 1] || optionButtons[0];
                            next.focus();

                        } else if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            const prev = optionButtons[index - 1] || optionButtons[lastIdx];
                            prev.focus();

                        } else if (e.key === 'Home') {
                            e.preventDefault();
                            optionButtons[0].focus();

                        } else if (e.key === 'End') {
                            e.preventDefault();
                            optionButtons[lastIdx].focus();

                        } else if (e.key === 'Escape') {
                            e.preventDefault();
                            closeMenu();
                            toggleButton.focus();

                        } else if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            optionButtons.forEach(o => o.setAttribute('aria-selected', 'false'));
                            optionBtn.setAttribute('aria-selected', 'true');

                            optionBtn.closest('li').click();
                            toggleButton.focus();

                        } else if (e.key === 'Tab') {
                            setTimeout(() => {
                                if (!container.contains(document.activeElement)) closeMenu();
                            }, 0);
                        }
                    });
                });

                document.addEventListener('click', (e) => {
                    if (!container.contains(e.target) && isMenuOpen()) {
                        closeMenu();
                    }
                });

                container.dataset.sortingAccessibilityFixed = 'true';
            });
        };

        apply();

        const observer = new MutationObserver(() => apply());
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function fixSortingButton() {
        const apply = () => {
            const container = document.querySelector('.boost-sd__sorting');
            if (!container) return;
            const btn = container.querySelector('.boost-sd__sorting-button');
            if (!btn) return;
            const value = container.querySelector('.boost-sd__sorting-value');
            const text = value && value.textContent.trim() ? value.textContent.trim() : '';
            btn.setAttribute('aria-label', text ? `Sort by ${text}` : 'Sort by');
        };

        apply();

        const observer = new MutationObserver(() => apply());
        observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    function fixBoostSearchAccessibility() {
        const inputSelector = '#boost-sd__search-widget-init-input-0';
        const wrapperSelector = '#boost-sd__search-widget-init-wrapper';
        const itemSelector = '.boost-sd__suggestion-queries-item, .boost-sd__view-all';
        const selectedClass = 'boost-sd__suggestion-queries-item-selected';

        function init() {
            const searchInput = document.querySelector(inputSelector);
            const resultsContainer = document.querySelector(wrapperSelector);

            if (!searchInput || !resultsContainer) {
                setTimeout(init, 500);
                return;
            }

            searchInput.setAttribute('role', 'combobox');
            searchInput.setAttribute('aria-expanded', 'false');
            searchInput.setAttribute('aria-autocomplete', 'list');
            searchInput.setAttribute('aria-controls', resultsContainer.id);
            searchInput.setAttribute('aria-owns', resultsContainer.id);

            resultsContainer.setAttribute('role', 'listbox');
            resultsContainer.setAttribute('aria-label', 'Search results');

            let isObserving = false;

            const observer = new MutationObserver(() => {
                const isVisible = resultsContainer.style.display !== 'none' &&
                                resultsContainer.innerHTML.trim() !== '' &&
                                resultsContainer.offsetParent !== null;

                searchInput.setAttribute('aria-expanded', isVisible ? 'true' : 'false');

                const activeItem = resultsContainer.querySelector('.' + selectedClass);
                const allItems = resultsContainer.querySelectorAll(itemSelector);

                allItems.forEach((item, index) => {
                    if (item.getAttribute('role') !== 'option') {
                        item.setAttribute('role', 'option');
                    }
                    if (!item.id) item.id = 'boost-option-' + index;
                    const link = item.querySelector('a');
                    if (link) link.setAttribute('tabindex', '-1');
                });

                if (activeItem) {
                    if (!activeItem.id) {
                        activeItem.id = 'boost-selected-option-' + Date.now();
                    }
                    searchInput.setAttribute('aria-activedescendant', activeItem.id);
                    activeItem.setAttribute('aria-selected', 'true');
                    const activeLink = activeItem.querySelector('a');
                    if (activeLink) activeLink.setAttribute('tabindex', '0');
                } else {
                    searchInput.removeAttribute('aria-activedescendant');
                    allItems.forEach(i => i.setAttribute('aria-selected', 'false'));
                }
            });

            function startObserver() {
                if (isObserving) return;
                observer.observe(resultsContainer, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                    attributeFilter: ['class', 'style']
                });
                isObserving = true;
            }

            function stopObserver() {
                if (!isObserving) return;
                observer.disconnect();
                isObserving = false;
                searchInput.setAttribute('aria-expanded', 'false');
                searchInput.removeAttribute('aria-activedescendant');
            }

            searchInput.addEventListener('focus', () => {
                startObserver();
                const isVisible = resultsContainer.style.display !== 'none';
                searchInput.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
            });

            searchInput.addEventListener('blur', () => {
                stopObserver();
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
    }

    fixBoostSearchAccessibility();

    function fixHeaderSearchAccessibility() {
        const inputSelector = '#boost-sd__search-widget-init-input-1';
        const itemSelector = '.boost-sd__suggestion-queries-item, .boost-sd__view-all';
        const selectedClass = 'boost-sd__suggestion-queries-item-selected';
        const modalSelector = '#nt_search_canvas';

        function init() {
            const searchInput = document.querySelector(inputSelector);
            const modal = document.querySelector(modalSelector);
            const resultsContainer = document.querySelector('#boost-sd__search-widget-init-wrapper[aria-controls="boost-sd__search-widget-init-input-1"]');

            if (!searchInput || !modal || !resultsContainer) {
                setTimeout(init, 500);
                return;
            }

            let isObserving = false;

            const observer = new MutationObserver(() => {
                const isVisible = resultsContainer.style.display !== 'none' &&
                                resultsContainer.innerHTML.trim() !== '' &&
                                resultsContainer.offsetParent !== null;

                searchInput.setAttribute('aria-expanded', isVisible ? 'true' : 'false');

                const activeItem = resultsContainer.querySelector('.' + selectedClass);
                const allItems = resultsContainer.querySelectorAll(itemSelector);

                allItems.forEach((item, index) => {
                    if (item.getAttribute('role') !== 'option') {
                        item.setAttribute('role', 'option');
                    }
                    if (!item.id) item.id = 'boost-option-header-' + index;
                    const link = item.querySelector('a');
                    if (link) link.setAttribute('tabindex', '-1');
                });

                if (activeItem) {
                    if (!activeItem.id) {
                        activeItem.id = 'boost-selected-option-header-' + Date.now();
                    }
                    searchInput.setAttribute('aria-activedescendant', activeItem.id);
                    activeItem.setAttribute('aria-selected', 'true');
                    const activeLink = activeItem.querySelector('a');
                    if (activeLink) activeLink.setAttribute('tabindex', '0');
                } else {
                    searchInput.removeAttribute('aria-activedescendant');
                    allItems.forEach(i => i.setAttribute('aria-selected', 'false'));
                }
            });

            function startObserver() {
                if (isObserving) return;
                observer.observe(resultsContainer, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                    attributeFilter: ['class', 'style']
                });
                isObserving = true;
            }

            function stopObserver() {
                if (!isObserving) return;
                observer.disconnect();
                isObserving = false;
                searchInput.setAttribute('aria-expanded', 'false');
                searchInput.removeAttribute('aria-activedescendant');
            }

            function setupInput() {
                searchInput.setAttribute('role', 'combobox');
                searchInput.setAttribute('aria-expanded', 'false');
                searchInput.setAttribute('aria-autocomplete', 'list');
                searchInput.setAttribute('aria-controls', resultsContainer.id);
                searchInput.setAttribute('aria-owns', resultsContainer.id);
                searchInput.removeAttribute('aria-hidden');
                searchInput.removeAttribute('tabindex');

                resultsContainer.setAttribute('role', 'listbox');
                resultsContainer.setAttribute('aria-label', 'Search results');
            }

            function hideInput() {
                stopObserver();
                searchInput.setAttribute('aria-hidden', 'true');
                searchInput.setAttribute('tabindex', '-1');
            }

            const modalObserver = new MutationObserver(() => {
                if (modal.classList.contains('act_opened')) {
                    setupInput();
                    setTimeout(startObserver, 100);
                } else {
                    hideInput();
                }
            });

            modalObserver.observe(modal, {
                attributes: true,
                attributeFilter: ['class']
            });

            if (modal.classList.contains('act_opened')) {
                setupInput();
                startObserver();
            }

            searchInput.addEventListener('focus', () => {
                if (modal.classList.contains('act_opened')) {
                    startObserver();
                    const isVisible = resultsContainer.style.display !== 'none';
                    searchInput.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
                }
            });

            searchInput.addEventListener('blur', () => {
                stopObserver();
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
    }

    fixHeaderSearchAccessibility();

    fixSortingButton();
      
    fixAriaLabelButton();

    // ensureSlideRegionsFallback();

    ensureProductListSemantics();

    fixFornoSwatchesKeyboard();

    fixProductCheckbox();

    fixProductFocusOrder();

    fixAddToCartFocusOrder();

    fixProductThumbnails();

    fixStickyFooter();

    fixCartQuantityFocusOrder();

    fixFeatureColumnRedundantLinks();

    fixSortingDropdownAccessibility();

        function trapFocusReuse2nd(container, btnOpenModal, focusableElements, hasBtnBack) {
        let focusables = [];
        if (focusableElements) {
            focusables = focusableElements;
        } else {
            focusables = getFocusableElementsReuse2nd(container);
        }

        if (focusables.length === 0) return;

        // Focus first element
        focusables[0].focus();

        container.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;

            const first = focusables[0];
            const last = focusables[focusables.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });

        let btnsBack = undefined;


        if (hasBtnBack) {
            btnsBack = container.querySelectorAll('.btn_back');
            btnsBack.forEach(btnClick => {
                btnClick.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        btnClick.click();
                        btnOpenModal.focus();
                    }
                });
                btnClick.addEventListener('click', () => {
                    btnClick.click();
                    btnOpenModal.focus();
                });
            });
        }

        const offEscape = onEscape(() => {
            if (btnOpenModal) {
                const btn = btnOpenModal.querySelector('a');
                if (btn) {
                    btn.focus();
                } else {
                    if (hasBtnBack) {
                        btnsBack[0].click();
                        btnOpenModal.focus();
                    } else {
                        btnOpenModal.focus();
                    }
                }

            }
        });


        function onEscape(handler) {
            function listener(e) {
                if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
                    handler(e);
                }
            }
            container.addEventListener('keydown', listener);
            return () => container.removeEventListener('keydown', listener);
        }
    }

    function getFocusableElementsReuse2nd(container) {
        return Array.from(
            container.querySelectorAll(
                `
                    a[href]:not([tabindex="-1"]),
                    button:not([disabled]):not([tabindex="-1"]),
                    input:not([disabled]):not([type="hidden"]),
                    select:not([disabled]),
                    textarea:not([disabled]),
                    [tabindex]:not([tabindex="-1"])
                    `
            )
        );
    }

        function fixMobileMenuAccessibility() {
        const menuCanvas = document.querySelector('#nt_menu_canvas');
        if (!menuCanvas) return;

        const menuOpenBtn = document.querySelector('.push_side.push-menu-btn[data-id="#nt_menu_canvas"]');
        const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

        if (menuOpenBtn) {
            menuOpenBtn.setAttribute('role', 'button');
            menuOpenBtn.setAttribute('aria-label', 'Primary Menu');
            menuOpenBtn.setAttribute('aria-haspopup', 'dialog');
            menuOpenBtn.setAttribute('aria-expanded', 'false');
        }

        menuCanvas.setAttribute('aria-label', 'Primary menu');
        menuCanvas.setAttribute('role', 'dialog');
        let tabsContainer = null;
        let tabs = [];
        let panels = [];
        let focusTrapActive = false;
        let focusTrapHandler = null;
        let tabsInit = false;
        let expandButtonsInit = false;

        function getFocusableElements(container) {
            return Array.from(container.querySelectorAll(focusableSelector)).filter(el => {
                return el.offsetParent !== null && !el.disabled;
            });
        }

        function refreshMenuNodes() {
            tabsContainer = menuCanvas.querySelector('.mb_nav_tabs');
            tabs = tabsContainer ? Array.from(tabsContainer.querySelectorAll('.mb_nav_title')) : [];
            panels = Array.from(menuCanvas.querySelectorAll('.mb_nav_tab'));
        }

        function updatePanelFocusability() {
            if (panels.length === 0) refreshMenuNodes();
            if (panels.length === 0) return;

            panels.forEach(panel => {
                const isActive = panel.classList.contains('active');
                if (!isActive) {
                    panel.setAttribute('tabindex', '-1');
                    panel.setAttribute('aria-hidden', 'true');
                    panel.querySelectorAll(focusableSelector).forEach(el => {
                        el.setAttribute('tabindex', '-1');
                    });
                } else {
                    panel.removeAttribute('tabindex');
                    panel.removeAttribute('aria-hidden');
                    const focusableElements = panel.querySelectorAll('[tabindex="-1"]');
                    focusableElements.forEach(el => {
                        el.removeAttribute('tabindex');
                    });
                    panel.querySelectorAll('.nav_link_icon').forEach(icon => {
                        icon.setAttribute('tabindex', '0');
                    });
                }
            });
        }

        function initTablist() {
            if (tabsInit) return true;
            refreshMenuNodes();
            if (!tabsContainer || tabs.length === 0 || panels.length === 0) return false;

            tabsContainer.setAttribute('role', 'tablist');

            tabs.forEach((tab, index) => {
                const panelSelector = tab.getAttribute('data-id');
                const panel = panelSelector ? menuCanvas.querySelector(panelSelector) : null;
                const tabId = tab.id || `tab-${index}`;

                tab.id = tabId;
                tab.setAttribute('role', 'tab');
                tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
                tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

                if (panel && panelSelector) {
                    const panelId = panel.id || panelSelector.replace('#', '');
                    panel.id = panelId;
                    tab.setAttribute('aria-controls', panelId);
                    panel.setAttribute('role', 'tabpanel');
                    panel.setAttribute('aria-labelledby', tabId);
                }

                tab.addEventListener('click', () => activateTab(index));
                tab.addEventListener('keydown', (e) => handleTabKeydown(e, index));
            });

            updatePanelFocusability();
            tabsInit = true;
            return true;
        }

        function activateTab(index) {
            if (tabs.length === 0) return;
            tabs.forEach((tab, i) => {
                const isSelected = i === index;
                tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                tab.setAttribute('tabindex', isSelected ? '0' : '-1');
                const panelId = tab.getAttribute('data-id');
                const panel = panelId ? menuCanvas.querySelector(panelId) : null;
                if (panel) {
                    if (isSelected) {
                        panel.classList.add('active');
                    } else {
                        panel.classList.remove('active');
                    }
                }
            });
            updatePanelFocusability();
            tabs[index].focus();
        }

        function handleTabKeydown(e, currentIndex) {
            if (tabs.length === 0) return;
            let newIndex = currentIndex;
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                newIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
                activateTab(newIndex);
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                newIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
                activateTab(newIndex);
            } else if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                activateTab(currentIndex);
            }
        }

        function initExpandButtons() {
            if (expandButtonsInit) return true;

            const info = menuCanvas.querySelector('.menu_infos_text');
            if(info) {
                info.setAttribute('role', 'list');

                const items = [];
                let currentItem = null;

                Array.from(info.childNodes).forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'I') {
                    // start new listitem
                    currentItem = document.createElement('div');
                    currentItem.setAttribute('role', 'listitem');
                    items.push(currentItem);
                    currentItem.appendChild(node);
                    if(node.classList.contains('pe-7s-call')) {
                        const hiddenText = document.createElement('span');
                        hiddenText.classList.add('visually-hidden');
                        hiddenText.innerText = 'Call ';
                        node.after(hiddenText);
                    }
                } else if (currentItem && node.nodeName !== 'BR') {
                    currentItem.appendChild(node);
                }
                });

                // clear and re-append
                info.innerHTML = '';
                items.forEach(item => info.appendChild(item));
            }

            const menuItems = menuCanvas.querySelectorAll('.menu-item-has-children');
            if (menuItems.length === 0) return false;

            menuItems.forEach(item => {
                const link = item.querySelector('a');
                const icon = item.querySelector('.nav_link_icon');
                const submenu = item.querySelector('.sub-menu, .sub-sub-menu');

                if (!icon || !link) return;

                const newLinkWrapper = document.createElement('a');
                newLinkWrapper.setAttribute('role', 'none');
                newLinkWrapper.appendChild(link);
                newLinkWrapper.appendChild(icon);
                item.prepend(newLinkWrapper);

                const menuText = link.querySelector('.nav_link_txt');
                const labelText = menuText ? menuText.textContent.trim() : 'submenu';

                icon.setAttribute('tabindex', '0');
                icon.setAttribute('role', 'button');
                icon.setAttribute('aria-label', `${labelText} submenu`);
                
                const updateExpandedState = () => {
                    if (!submenu) return;
                    const isVisible = window.getComputedStyle(submenu).display !== 'none';
                    icon.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
                    if (submenu) submenu.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
                };

                updateExpandedState();

                if (submenu) {
                    const submenuObserver = new MutationObserver(updateExpandedState);
                    submenuObserver.observe(submenu, {
                        attributes: true,
                        attributeFilter: ['class', 'style']
                    });
                }

                // Prevent link navigation on click
                icon.addEventListener('click', (e) => {
                    e.preventDefault(); 
                });

                // Map keyboard interaction to trigger a native click
                icon.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault(); 
                        icon.click(); 
                    }
                });
            });

            expandButtonsInit = true;
            return true;
        }

        function activateFocusTrap() {
            if (focusTrapActive) return;
            focusTrapActive = true;
            const focusables = getFocusableElements(menuCanvas);
            if (focusables.length > 0) focusables[0].focus();

            focusTrapHandler = (e) => {
                if (e.key !== 'Tab') return;
                const focusableElements = getFocusableElements(menuCanvas);
                if (focusableElements.length === 0) return;

                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                if (e.shiftKey && document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                } else if (!e.shiftKey && document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            };
            menuCanvas.addEventListener('keydown', focusTrapHandler);
        }

        function deactivateFocusTrap() {
            if (!focusTrapActive) return;
            focusTrapActive = false;
            if (focusTrapHandler) {
                menuCanvas.removeEventListener('keydown', focusTrapHandler);
                focusTrapHandler = null;
            }
            if (menuOpenBtn) menuOpenBtn.focus();
        }

        const menuObserver = new MutationObserver(() => {
            const isOpen = menuCanvas.classList.contains('act_opened');
            if (!tabsInit) {
                initTablist();
                initExpandButtons();
            }
            if (isOpen) {
                if (menuOpenBtn) menuOpenBtn.setAttribute('aria-expanded', 'true');
                setTimeout(() => {
                    updatePanelFocusability();
                    activateFocusTrap();
                }, 100);
            } else {
                if (menuOpenBtn) menuOpenBtn.setAttribute('aria-expanded', 'false');
                deactivateFocusTrap();
            }
        });

        menuObserver.observe(menuCanvas, {
            attributes: true,
            attributeFilter: ['class']
        });

        const menuContentObserver = new MutationObserver(() => {
            const tabsReady = initTablist();
            const expandReady = initExpandButtons();
            if (tabsReady && expandReady) {
                menuContentObserver.disconnect();
            }
        });

        menuContentObserver.observe(menuCanvas, {
            childList: true,
            subtree: true
        });

        initTablist();
        initExpandButtons();

        if (menuCanvas.classList.contains('act_opened')) {
            updatePanelFocusability();
            activateFocusTrap();
        }
    }

    fixMobileMenuAccessibility();


});
